(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ReactDevToolsBackend"] = factory();
	else
		root["ReactDevToolsBackend"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var Agent = __webpack_require__(1);
	var Bridge = __webpack_require__(6);
	var installGlobalHook = __webpack_require__(31);
	var installRelayHook = __webpack_require__(32);
	var inject = __webpack_require__(33);
	var setupRNStyle = __webpack_require__(43);
	var setupRelay = __webpack_require__(45);
	
	installGlobalHook(window);
	installRelayHook(window);
	
	if (window.document) {
	  // This shell is universal, and might be used inside a web app.
	  window.__REACT_DEVTOOLS_GLOBAL_HOOK__.on('react-devtools', function (agent) {
	    var setupHighlighter = __webpack_require__(46);
	    setupHighlighter(agent);
	  });
	}
	
	function connectToDevTools(options) {
	  var _ref = options || {},
	      _ref$host = _ref.host,
	      host = _ref$host === undefined ? 'localhost' : _ref$host,
	      _ref$port = _ref.port,
	      port = _ref$port === undefined ? 8097 : _ref$port,
	      _ref$resolveRNStyle = _ref.resolveRNStyle,
	      resolveRNStyle = _ref$resolveRNStyle === undefined ? null : _ref$resolveRNStyle,
	      _ref$isAppActive = _ref.isAppActive,
	      isAppActive = _ref$isAppActive === undefined ? function () {
	    return true;
	  } : _ref$isAppActive;
	
	  function scheduleRetry() {
	    // Two seconds because RN had issues with too fast retries.
	    setTimeout(function () {
	      return connectToDevTools(options);
	    }, 2000);
	  }
	
	  if (!isAppActive()) {
	    // If the app is in background, maybe retry later.
	    // Don't actually attempt to connect until we're in foreground.
	    scheduleRetry();
	    return;
	  }
	
	  var messageListeners = [];
	  var closeListeners = [];
	  var uri = 'ws://' + host + ':' + port;
	  var ws = new window.WebSocket(uri);
	  ws.onclose = handleClose;
	  ws.onerror = handleClose;
	  ws.onmessage = handleMessage;
	  ws.onopen = function () {
	    var wall = {
	      listen: function listen(fn) {
	        messageListeners.push(fn);
	      },
	      onClose: function onClose(fn) {
	        closeListeners.push(fn);
	      },
	      send: function send(data) {
	        ws.send(JSON.stringify(data));
	      }
	    };
	    setupBackend(wall, resolveRNStyle);
	  };
	
	  var hasClosed = false;
	  function handleClose() {
	    if (!hasClosed) {
	      hasClosed = true;
	      scheduleRetry();
	      closeListeners.forEach(function (fn) {
	        return fn();
	      });
	    }
	  }
	
	  function handleMessage(evt) {
	    var data;
	    // <hack>
	    // This branch can be dropped when we don't care about supporting
	    // Nuclide Inspector versions before https://github.com/facebook/nuclide/pull/1021.
	    // Inspector used to send this message but it is unnecessary now.
	    if (evt.data.indexOf('eval:') === 0) {
	      return;
	    }
	    // </hack>
	    try {
	      data = JSON.parse(evt.data);
	    } catch (e) {
	      console.error('failed to parse json: ' + evt.data);
	      return;
	    }
	    messageListeners.forEach(function (fn) {
	      try {
	        fn(data);
	      } catch (e) {
	        // jsc doesn't play so well with tracebacks that go into eval'd code,
	        // so the stack trace here will stop at the `eval()` call. Getting the
	        // message that caused the error is the best we can do for now.
	        console.log(data);
	        throw e;
	      }
	    });
	  }
	}
	
	function setupBackend(wall, resolveRNStyle) {
	  wall.onClose(function () {
	    if (agent) {
	      agent.emit('shutdown');
	    }
	    // This appears necessary for plugin (e.g. Relay) cleanup.
	    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.emit('shutdown');
	    bridge = null;
	    agent = null;
	    console.log('closing devtools');
	  });
	
	  var bridge = new Bridge(wall);
	  var agent = new Agent(window, {
	    rnStyle: !!resolveRNStyle,
	    rnStyleMeasure: !!resolveRNStyle
	  });
	  agent.addBridge(bridge);
	
	  if (resolveRNStyle) {
	    setupRNStyle(bridge, agent, resolveRNStyle);
	  }
	
	  setupRelay(bridge, agent, window.__REACT_DEVTOOLS_GLOBAL_HOOK__);
	
	  var _connectTimeout = setTimeout(function () {
	    console.warn('react-devtools agent got no connection');
	  }, 20000);
	
	  agent.once('connected', function () {
	    if (!agent) {
	      return;
	    }
	    inject(window.__REACT_DEVTOOLS_GLOBAL_HOOK__, agent);
	    clearTimeout(_connectTimeout);
	  });
	}
	
	module.exports = { connectToDevTools: connectToDevTools };

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(2),
	    EventEmitter = _require.EventEmitter;
	
	var assign = __webpack_require__(3);
	var guid = __webpack_require__(4);
	var getIn = __webpack_require__(5);
	
	/**
	 * The agent lives on the page in the same context as React, observes events
	 * from the `backend`, and communicates (via a `Bridge`) with the frontend.
	 *
	 * It is responsible for generating string IDs (ElementID) for each react
	 * element, maintaining a mapping of those IDs to elements, handling messages
	 * from the frontend, and translating between react elements and native
	 * handles.
	 *
	 *
	 *   React
	 *     |
	 *     v
	 *  backend
	 *     |
	 *     v
	 *  -----------
	 * | **Agent** |
	 *  -----------
	 *     ^
	 *     |
	 *     v
	 *  (Bridge)
	 *     ^
	 *     |
	 * serialization
	 *     |
	 *     v
	 *  (Bridge)
	 *     ^
	 *     |
	 *     v
	 *  ----------------
	 * | Frontend Store |
	 *  ----------------
	 *
	 *
	 * Events from the `backend`:
	 * - root (got a root)
	 * - mount (a component mounted)
	 * - update (a component updated)
	 * - unmount (a component mounted)
	 *
	 * Events from the `frontend` Store:
	 * - see `addBridge` for subscriptions
	 *
	 * Events that Agent fires:
	 * - selected
	 * - hideHighlight
	 * - startInspecting
	 * - stopInspecting
	 * - shutdown
	 * - highlight /highlightMany
	 * - setSelection
	 * - root
	 * - mount
	 * - update
	 * - unmount
	 */
	var Agent = function (_EventEmitter) {
	  _inherits(Agent, _EventEmitter);
	
	  function Agent(global, capabilities) {
	    _classCallCheck(this, Agent);
	
	    var _this = _possibleConstructorReturn(this, (Agent.__proto__ || Object.getPrototypeOf(Agent)).call(this));
	
	    _this.global = global;
	    _this.internalInstancesById = new Map();
	    _this.idsByInternalInstances = new WeakMap();
	    _this.renderers = new Map();
	    _this.elementData = new Map();
	    _this.roots = new Set();
	    _this.reactInternals = {};
	    var lastSelected;
	    _this.on('selected', function (id) {
	      var data = _this.elementData.get(id);
	      if (data && data.publicInstance && _this.global.$r === lastSelected) {
	        _this.global.$r = data.publicInstance;
	        lastSelected = data.publicInstance;
	      }
	    });
	    _this._prevSelected = null;
	    _this._scrollUpdate = false;
	    var isReactDOM = window.document && typeof window.document.createElement === 'function';
	    _this.capabilities = assign({
	      scroll: isReactDOM && typeof window.document.body.scrollIntoView === 'function',
	      dom: isReactDOM,
	      editTextContent: false
	    }, capabilities);
	
	    if (isReactDOM) {
	      _this._updateScroll = _this._updateScroll.bind(_this);
	      window.addEventListener('scroll', _this._onScroll.bind(_this), true);
	    }
	    return _this;
	  }
	
	  // returns an "unsubscribe" function
	
	  // the window or global -> used to "make a value available in the console"
	
	
	  _createClass(Agent, [{
	    key: 'sub',
	    value: function sub(ev, fn) {
	      var _this2 = this;
	
	      this.on(ev, fn);
	      return function () {
	        _this2.removeListener(ev, fn);
	      };
	    }
	  }, {
	    key: 'setReactInternals',
	    value: function setReactInternals(renderer, reactInternals) {
	      this.reactInternals[renderer] = reactInternals;
	    }
	  }, {
	    key: 'addBridge',
	    value: function addBridge(bridge) {
	      var _this3 = this;
	
	      /** Events received from the frontend **/
	      // the initial handshake
	      bridge.on('requestCapabilities', function () {
	        bridge.send('capabilities', _this3.capabilities);
	        _this3.emit('connected');
	      });
	      bridge.on('setState', this._setState.bind(this));
	      bridge.on('setProps', this._setProps.bind(this));
	      bridge.on('setContext', this._setContext.bind(this));
	      bridge.on('makeGlobal', this._makeGlobal.bind(this));
	      bridge.on('highlight', function (id) {
	        return _this3.highlight(id);
	      });
	      bridge.on('highlightMany', function (id) {
	        return _this3.highlightMany(id);
	      });
	      bridge.on('hideHighlight', function () {
	        return _this3.emit('hideHighlight');
	      });
	      bridge.on('startInspecting', function () {
	        return _this3.emit('startInspecting');
	      });
	      bridge.on('stopInspecting', function () {
	        return _this3.emit('stopInspecting');
	      });
	      bridge.on('selected', function (id) {
	        return _this3.emit('selected', id);
	      });
	      bridge.on('shutdown', function () {
	        return _this3.emit('shutdown');
	      });
	      bridge.on('changeTextContent', function (_ref) {
	        var id = _ref.id,
	            text = _ref.text;
	
	        var node = _this3.getNodeForID(id);
	        if (!node) {
	          return;
	        }
	        node.textContent = text;
	      });
	      // used to "inspect node in Elements pane"
	      bridge.on('putSelectedNode', function (id) {
	        window.__REACT_DEVTOOLS_GLOBAL_HOOK__.$node = _this3.getNodeForID(id);
	      });
	      // used to "view source in Sources pane"
	      bridge.on('putSelectedInstance', function (id) {
	        var node = _this3.elementData.get(id);
	        if (node) {
	          window.__REACT_DEVTOOLS_GLOBAL_HOOK__.$type = node.type;
	        } else {
	          window.__REACT_DEVTOOLS_GLOBAL_HOOK__.$type = null;
	        }
	        if (node && node.publicInstance) {
	          window.__REACT_DEVTOOLS_GLOBAL_HOOK__.$inst = node.publicInstance;
	        } else {
	          window.__REACT_DEVTOOLS_GLOBAL_HOOK__.$inst = null;
	        }
	      });
	      // used to select the inspected node ($0)
	      bridge.on('checkSelection', function () {
	        var newSelected = window.__REACT_DEVTOOLS_GLOBAL_HOOK__.$0;
	        if (newSelected !== _this3._prevSelected) {
	          _this3._prevSelected = newSelected;
	          var sentSelected = window.__REACT_DEVTOOLS_GLOBAL_HOOK__.$node;
	          if (newSelected !== sentSelected) {
	            _this3.selectFromDOMNode(newSelected, true);
	          }
	        }
	      });
	      bridge.on('scrollToNode', function (id) {
	        return _this3.scrollToNode(id);
	      });
	      bridge.on('traceupdatesstatechange', function (value) {
	        return _this3.emit('traceupdatesstatechange', value);
	      });
	      bridge.on('colorizerchange', function (value) {
	        return _this3.emit('colorizerchange', value);
	      });
	
	      /** Events sent to the frontend **/
	      this.on('root', function (id) {
	        return bridge.send('root', id);
	      });
	      this.on('mount', function (data) {
	        return bridge.send('mount', data);
	      });
	      this.on('update', function (data) {
	        return bridge.send('update', data);
	      });
	      this.on('unmount', function (id) {
	        bridge.send('unmount', id);
	        // once an element has been unmounted, the bridge doesn't need to be
	        // able to inspect it anymore.
	        bridge.forget(id);
	      });
	      this.on('setSelection', function (data) {
	        return bridge.send('select', data);
	      });
	    }
	  }, {
	    key: 'scrollToNode',
	    value: function scrollToNode(id) {
	      var node = this.getNodeForID(id);
	      if (!node) {
	        console.warn('unable to get the node for scrolling');
	        return;
	      }
	      var domElement = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
	      if (!domElement) {
	        console.warn('unable to get the domElement for scrolling');
	        return;
	      }
	
	      if (typeof domElement.scrollIntoViewIfNeeded === 'function') {
	        domElement.scrollIntoViewIfNeeded();
	      } else if (typeof domElement.scrollIntoView === 'function') {
	        domElement.scrollIntoView();
	      }
	      this.highlight(id);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(id) {
	      var data = this.elementData.get(id);
	      var node = this.getNodeForID(id);
	      if (data && node) {
	        this.emit('highlight', { node: node, name: data.name, props: data.props });
	      }
	    }
	  }, {
	    key: 'highlightMany',
	    value: function highlightMany(ids) {
	      var _this4 = this;
	
	      var nodes = [];
	      ids.forEach(function (id) {
	        var node = _this4.getNodeForID(id);
	        if (node) {
	          nodes.push(node);
	        }
	      });
	      if (nodes.length) {
	        this.emit('highlightMany', nodes);
	      }
	    }
	  }, {
	    key: 'getNodeForID',
	    value: function getNodeForID(id) {
	      var component = this.internalInstancesById.get(id);
	      if (!component) {
	        return null;
	      }
	      var renderer = this.renderers.get(id);
	      if (renderer && this.reactInternals[renderer].getNativeFromReactElement) {
	        return this.reactInternals[renderer].getNativeFromReactElement(component);
	      }
	      return null;
	    }
	  }, {
	    key: 'selectFromDOMNode',
	    value: function selectFromDOMNode(node, quiet) {
	      var id = this.getIDForNode(node);
	      if (!id) {
	        return;
	      }
	      this.emit('setSelection', { id: id, quiet: quiet });
	    }
	  }, {
	    key: 'selectFromReactInstance',
	    value: function selectFromReactInstance(instance, quiet) {
	      var id = this.getId(instance);
	      if (!id) {
	        console.log('no instance id', instance);
	        return;
	      }
	      this.emit('setSelection', { id: id, quiet: quiet });
	    }
	  }, {
	    key: 'getIDForNode',
	    value: function getIDForNode(node) {
	      if (!this.reactInternals) {
	        return null;
	      }
	      var component;
	      for (var renderer in this.reactInternals) {
	        // If a renderer doesn't know about a reactId, it will throw an error.
	        try {
	          // $FlowFixMe possibly null - it's not null
	          component = this.reactInternals[renderer].getReactElementFromNative(node);
	        } catch (e) {}
	        if (component) {
	          return this.getId(component);
	        }
	      }
	      return null;
	    }
	  }, {
	    key: '_setProps',
	    value: function _setProps(_ref2) {
	      var id = _ref2.id,
	          path = _ref2.path,
	          value = _ref2.value;
	
	      var data = this.elementData.get(id);
	      if (data && data.updater && data.updater.setInProps) {
	        data.updater.setInProps(path, value);
	      } else {
	        console.warn("trying to set props on a component that doesn't support it");
	      }
	    }
	  }, {
	    key: '_setState',
	    value: function _setState(_ref3) {
	      var id = _ref3.id,
	          path = _ref3.path,
	          value = _ref3.value;
	
	      var data = this.elementData.get(id);
	      if (data && data.updater && data.updater.setInState) {
	        data.updater.setInState(path, value);
	      } else {
	        console.warn("trying to set state on a component that doesn't support it");
	      }
	    }
	  }, {
	    key: '_setContext',
	    value: function _setContext(_ref4) {
	      var id = _ref4.id,
	          path = _ref4.path,
	          value = _ref4.value;
	
	      var data = this.elementData.get(id);
	      if (data && data.updater && data.updater.setInContext) {
	        data.updater.setInContext(path, value);
	      } else {
	        console.warn("trying to set state on a component that doesn't support it");
	      }
	    }
	  }, {
	    key: '_makeGlobal',
	    value: function _makeGlobal(_ref5) {
	      var id = _ref5.id,
	          path = _ref5.path;
	
	      var data = this.elementData.get(id);
	      if (!data) {
	        return;
	      }
	      var value;
	      if (path === 'instance') {
	        value = data.publicInstance;
	      } else {
	        value = getIn(data, path);
	      }
	      this.global.$tmp = value;
	      console.log('$tmp =', value);
	    }
	  }, {
	    key: 'getId',
	    value: function getId(internalInstance) {
	      if ((typeof internalInstance === 'undefined' ? 'undefined' : _typeof(internalInstance)) !== 'object' || !internalInstance) {
	        return internalInstance;
	      }
	      if (!this.idsByInternalInstances.has(internalInstance)) {
	        this.idsByInternalInstances.set(internalInstance, guid());
	        this.internalInstancesById.set(this.idsByInternalInstances.get(internalInstance), internalInstance);
	      }
	      return this.idsByInternalInstances.get(internalInstance);
	    }
	  }, {
	    key: 'addRoot',
	    value: function addRoot(renderer, internalInstance) {
	      var id = this.getId(internalInstance);
	      this.roots.add(id);
	      this.emit('root', id);
	    }
	  }, {
	    key: 'onMounted',
	    value: function onMounted(renderer, component, data) {
	      var _this5 = this;
	
	      var id = this.getId(component);
	      this.renderers.set(id, renderer);
	      this.elementData.set(id, data);
	
	      var send = assign({}, data);
	      if (send.children && send.children.map) {
	        send.children = send.children.map(function (c) {
	          return _this5.getId(c);
	        });
	      }
	      send.id = id;
	      send.canUpdate = send.updater && !!send.updater.forceUpdate;
	      delete send.type;
	      delete send.updater;
	      this.emit('mount', send);
	    }
	  }, {
	    key: 'onUpdated',
	    value: function onUpdated(component, data) {
	      var _this6 = this;
	
	      var id = this.getId(component);
	      this.elementData.set(id, data);
	
	      var send = assign({}, data);
	      if (send.children && send.children.map) {
	        send.children = send.children.map(function (c) {
	          return _this6.getId(c);
	        });
	      }
	      send.id = id;
	      send.canUpdate = send.updater && !!send.updater.forceUpdate;
	      delete send.type;
	      delete send.updater;
	      this.emit('update', send);
	    }
	  }, {
	    key: 'onUnmounted',
	    value: function onUnmounted(component) {
	      var id = this.getId(component);
	      this.elementData.delete(id);
	      this.roots.delete(id);
	      this.renderers.delete(id);
	      this.emit('unmount', id);
	      this.idsByInternalInstances.delete(component);
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll() {
	      if (!this._scrollUpdate) {
	        this._scrollUpdate = true;
	        window.requestAnimationFrame(this._updateScroll);
	      }
	    }
	  }, {
	    key: '_updateScroll',
	    value: function _updateScroll() {
	      this.emit('refreshMultiOverlay');
	      this._scrollUpdate = false;
	    }
	  }]);
	
	  return Agent;
	}(EventEmitter);
	
	module.exports = Agent;

/***/ },
/* 2 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	/* eslint-disable no-unused-vars */
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	function guid() {
	  return 'g' + Math.random().toString(16).substr(2);
	}
	
	module.exports = guid;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Retrieves the value from the path of nested objects
	 * @param  {Object} base Base or root object for path
	 * @param  {Array<String>} path nested path
	 * @return {any}      Value at end of path or `mull`
	 */
	function getIn(base, path) {
	  return path.reduce(function (obj, attr) {
	    if (obj) {
	      if (obj.hasOwnProperty(attr)) {
	        return obj[attr];
	      }
	      if (typeof obj[Symbol.iterator] === 'function') {
	        // Convert iterable to array and return array[index]
	        return [].concat(_toConsumableArray(obj))[attr];
	      }
	    }
	
	    return null;
	  }, base);
	}
	
	module.exports = getIn;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var consts = __webpack_require__(7);
	var hydrate = __webpack_require__(26);
	var dehydrate = __webpack_require__(27);
	var getIn = __webpack_require__(5);
	var performanceNow = __webpack_require__(28);
	
	// Custom polyfill that runs the queue with a backoff.
	// If you change it, make sure it behaves reasonably well in Firefox.
	var lastRunTimeMS = 5;
	var cancelIdleCallback = window.cancelIdleCallback || clearTimeout;
	var requestIdleCallback = window.requestIdleCallback || function (cb, options) {
	  // Magic numbers determined by tweaking in Firefox.
	  // There is no special meaning to them.
	  var delayMS = 3000 * lastRunTimeMS;
	  if (delayMS > 500) {
	    delayMS = 500;
	  }
	
	  return setTimeout(function () {
	    var startTime = performanceNow();
	    cb({
	      didTimeout: false,
	      timeRemaining: function timeRemaining() {
	        return Infinity;
	      }
	    });
	    var endTime = performanceNow();
	    lastRunTimeMS = (endTime - startTime) / 1000;
	  }, delayMS);
	};
	
	/**
	 * The bridge is responsible for serializing requests between the Agent and
	 * the Frontend Store. It needs to be connected to a Wall object that can send
	 * JSONable data to the bridge on the other side.
	 *
	 * complex data
	 *     |
	 *     v
	 *  [Bridge]
	 *     |
	 * jsonable data
	 *     |
	 *     v
	 *   [wall]
	 *     |
	 *     v
	 * ~ some barrier ~
	 *     |
	 *     v
	 *   [wall]
	 *     |
	 *     v
	 *  [Bridge]
	 *     |
	 *     v
	 * "hydrated" data
	 *
	 * When an item is passed in that can't be serialized (anything other than a
	 * plain array, object, or literal value), the object is "cleaned", and
	 * rehydrated on the other side with `Symbol` attributes indicating that the
	 * object needs to be inspected for more detail.
	 *
	 * Example:
	 *
	 * bridge.send('evname', {id: 'someid', foo: MyCoolObjectInstance})
	 * ->
	 * shows up, hydrated as
	 * {
	 *   id: 'someid',
	 *   foo: {
	 *     [consts.name]: 'MyCoolObjectInstance',
	 *     [consts.type]: 'object',
	 *     [consts.meta]: {},
	 *     [consts.inspected]: false,
	 *   }
	 * }
	 *
	 * The `consts` variables are Symbols, and as such are non-ennumerable.
	 * The front-end therefore needs to check for `consts.inspected` on received
	 * objects, and can thereby display object proxies and inspect them.
	 *
	 * Complex objects that are passed are expected to have a top-level `id`
	 * attribute, which is used for later lookup + inspection. Once it has been
	 * determined that an object is no longer needed, call `.forget(id)` to clean
	 * up.
	 */
	var Bridge = function () {
	  function Bridge(wall) {
	    _classCallCheck(this, Bridge);
	
	    this._cbs = new Map();
	    this._inspectables = new Map();
	    this._cid = 0;
	    this._listeners = {};
	    this._buffer = [];
	    this._flushHandle = null;
	    this._callers = {};
	    this._paused = false;
	    this._wall = wall;
	
	    wall.listen(this._handleMessage.bind(this));
	  }
	
	  _createClass(Bridge, [{
	    key: 'inspect',
	    value: function inspect(id, path, cb) {
	      var _cid = this._cid++;
	      this._cbs.set(_cid, function (data, cleaned, proto, protoclean) {
	        if (cleaned.length) {
	          hydrate(data, cleaned);
	        }
	        if (proto && protoclean.length) {
	          hydrate(proto, protoclean);
	        }
	        if (proto) {
	          data[consts.proto] = proto;
	        }
	        cb(data);
	      });
	
	      this._wall.send({
	        type: 'inspect',
	        callback: _cid,
	        path: path,
	        id: id
	      });
	    }
	  }, {
	    key: 'call',
	    value: function call(name, args, cb) {
	      var _cid = this._cid++;
	      this._cbs.set(_cid, cb);
	
	      this._wall.send({
	        type: 'call',
	        callback: _cid,
	        args: args,
	        name: name
	      });
	    }
	  }, {
	    key: 'onCall',
	    value: function onCall(name, handler) {
	      if (this._callers[name]) {
	        throw new Error('only one call handler per call name allowed');
	      }
	      this._callers[name] = handler;
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this._wall.send({
	        type: 'pause'
	      });
	    }
	  }, {
	    key: 'resume',
	    value: function resume() {
	      this._wall.send({
	        type: 'resume'
	      });
	    }
	  }, {
	    key: 'setInspectable',
	    value: function setInspectable(id, data) {
	      var prev = this._inspectables.get(id);
	      if (!prev) {
	        this._inspectables.set(id, data);
	        return;
	      }
	      this._inspectables.set(id, _extends({}, prev, data));
	    }
	  }, {
	    key: 'send',
	    value: function send(evt, data) {
	      this._buffer.push({ evt: evt, data: data });
	      this.scheduleFlush();
	    }
	  }, {
	    key: 'scheduleFlush',
	    value: function scheduleFlush() {
	      if (!this._flushHandle && this._buffer.length) {
	        var timeout = this._paused ? 5000 : 500;
	        this._flushHandle = requestIdleCallback(this.flushBufferWhileIdle.bind(this), { timeout: timeout });
	      }
	    }
	  }, {
	    key: 'cancelFlush',
	    value: function cancelFlush() {
	      if (this._flushHandle) {
	        cancelIdleCallback(this._flushHandle);
	        this._flushHandle = null;
	      }
	    }
	  }, {
	    key: 'flushBufferWhileIdle',
	    value: function flushBufferWhileIdle(deadline) {
	      this._flushHandle = null;
	
	      // Magic numbers were determined by tweaking in a heavy UI and seeing
	      // what performs reasonably well both when DevTools are hidden and visible.
	      // The goal is that we try to catch up but avoid blocking the UI.
	      // When paused, it's okay to lag more, but not forever because otherwise
	      // when user activates React tab, it will freeze syncing.
	      var chunkCount = this._paused ? 20 : 10;
	      var chunkSize = Math.round(this._buffer.length / chunkCount);
	      var minChunkSize = this._paused ? 50 : 100;
	
	      while (this._buffer.length && (deadline.timeRemaining() > 0 || deadline.didTimeout)) {
	        var take = Math.min(this._buffer.length, Math.max(minChunkSize, chunkSize));
	        var currentBuffer = this._buffer.splice(0, take);
	        this.flushBufferSlice(currentBuffer);
	      }
	
	      if (this._buffer.length) {
	        this.scheduleFlush();
	      }
	    }
	  }, {
	    key: 'flushBufferSlice',
	    value: function flushBufferSlice(bufferSlice) {
	      var _this = this;
	
	      var events = bufferSlice.map(function (_ref) {
	        var evt = _ref.evt,
	            data = _ref.data;
	
	        var cleaned = [];
	        var san = dehydrate(data, cleaned);
	        if (cleaned.length) {
	          _this.setInspectable(data.id, data);
	        }
	        return { type: 'event', evt: evt, data: san, cleaned: cleaned };
	      });
	      this._wall.send({ type: 'many-events', events: events });
	    }
	  }, {
	    key: 'forget',
	    value: function forget(id) {
	      this._inspectables.delete(id);
	    }
	  }, {
	    key: 'on',
	    value: function on(evt, fn) {
	      if (!this._listeners[evt]) {
	        this._listeners[evt] = [fn];
	      } else {
	        this._listeners[evt].push(fn);
	      }
	    }
	  }, {
	    key: 'off',
	    value: function off(evt, fn) {
	      if (!this._listeners[evt]) {
	        return;
	      }
	      var ix = this._listeners[evt].indexOf(fn);
	      if (ix !== -1) {
	        this._listeners[evt].splice(ix, 1);
	      }
	    }
	  }, {
	    key: 'once',
	    value: function once(evt, fn) {
	      var self = this;
	      var listener = function listener() {
	        fn.apply(this, arguments);
	        self.off(evt, listener);
	      };
	      this.on(evt, listener);
	    }
	  }, {
	    key: '_handleMessage',
	    value: function _handleMessage(payload) {
	      var _this2 = this;
	
	      if (payload.type === 'resume') {
	        this._paused = false;
	        this.scheduleFlush();
	        return;
	      }
	
	      if (payload.type === 'pause') {
	        this._paused = true;
	        this.cancelFlush();
	        return;
	      }
	
	      if (payload.type === 'callback') {
	        var callback = this._cbs.get(payload.id);
	        if (callback) {
	          callback.apply(undefined, _toConsumableArray(payload.args));
	          this._cbs.delete(payload.id);
	        }
	        return;
	      }
	
	      if (payload.type === 'call') {
	        this._handleCall(payload.name, payload.args, payload.callback);
	        return;
	      }
	
	      if (payload.type === 'inspect') {
	        this._inspectResponse(payload.id, payload.path, payload.callback);
	        return;
	      }
	
	      if (payload.type === 'event') {
	        // console.log('[bridge<-]', payload.evt);
	        if (payload.cleaned) {
	          hydrate(payload.data, payload.cleaned);
	        }
	        var fns = this._listeners[payload.evt];
	        var data = payload.data;
	        if (fns) {
	          fns.forEach(function (fn) {
	            return fn(data);
	          });
	        }
	      }
	
	      if (payload.type === 'many-events') {
	        payload.events.forEach(function (event) {
	          // console.log('[bridge<-]', payload.evt);
	          if (event.cleaned) {
	            hydrate(event.data, event.cleaned);
	          }
	          var handlers = _this2._listeners[event.evt];
	          if (handlers) {
	            handlers.forEach(function (fn) {
	              return fn(event.data);
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: '_handleCall',
	    value: function _handleCall(name, args, callback) {
	      if (!this._callers[name]) {
	        console.warn('unknown call: "' + name + '"');
	        return;
	      }
	      args = !Array.isArray(args) ? [args] : args;
	      var result;
	      try {
	        result = this._callers[name].apply(null, args);
	      } catch (e) {
	        console.error('Failed to call', e);
	        return;
	      }
	      this._wall.send({
	        type: 'callback',
	        id: callback,
	        args: [result]
	      });
	    }
	  }, {
	    key: '_inspectResponse',
	    value: function _inspectResponse(id, path, callback) {
	      var inspectable = this._inspectables.get(id);
	      var result = {};
	      var cleaned = [];
	      var proto = null;
	      var protoclean = [];
	
	      if (inspectable) {
	        var val = getIn(inspectable, path);
	        var protod = false;
	        var isFn = typeof val === 'function';
	
	        if (val && typeof val[Symbol.iterator] === 'function') {
	          var iterVal = Object.create({}); // flow throws "object literal incompatible with object type"
	          var count = 0;
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = val[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var entry = _step.value;
	
	              if (count > 100) {
	                // TODO: replace this if block with better logic to handle large iterables
	                break;
	              }
	              iterVal[count] = entry;
	              count++;
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          val = iterVal;
	        }
	
	        Object.getOwnPropertyNames(val).forEach(function (name) {
	          if (name === '__proto__') {
	            protod = true;
	          }
	          if (isFn && (name === 'arguments' || name === 'callee' || name === 'caller')) {
	            return;
	          }
	          result[name] = dehydrate(val[name], cleaned, [name]);
	        });
	
	        /* eslint-disable no-proto */
	        if (!protod && val.__proto__ && val.constructor.name !== 'Object') {
	          var newProto = {};
	          var pIsFn = typeof val.__proto__ === 'function';
	          Object.getOwnPropertyNames(val.__proto__).forEach(function (name) {
	            if (pIsFn && (name === 'arguments' || name === 'callee' || name === 'caller')) {
	              return;
	            }
	            newProto[name] = dehydrate(val.__proto__[name], protoclean, [name]);
	          });
	          proto = newProto;
	        }
	        /* eslint-enable no-proto */
	      }
	
	      this._wall.send({
	        type: 'callback',
	        id: callback,
	        args: [result, cleaned, proto, protoclean]
	      });
	    }
	  }]);
	
	  return Bridge;
	}();
	
	module.exports = Bridge;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _Symbol = __webpack_require__(8);
	
	module.exports = {
	  name: _Symbol('name'),
	  type: _Symbol('type'),
	  inspected: _Symbol('inspected'),
	  meta: _Symbol('meta'),
	  proto: _Symbol('proto')
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(9)() ? Symbol : __webpack_require__(10);


/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
		var symbol;
		if (typeof Symbol !== 'function') return false;
		symbol = Symbol('test symbol');
		try { String(symbol); } catch (e) { return false; }
		if (typeof Symbol.iterator === 'symbol') return true;
	
		// Return 'true' for polyfills
		if (typeof Symbol.isConcatSpreadable !== 'object') return false;
		if (typeof Symbol.iterator !== 'object') return false;
		if (typeof Symbol.toPrimitive !== 'object') return false;
		if (typeof Symbol.toStringTag !== 'object') return false;
		if (typeof Symbol.unscopables !== 'object') return false;
	
		return true;
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	// ES2015 Symbol polyfill for environments that do not support it (or partially support it_
	
	'use strict';
	
	var d              = __webpack_require__(11)
	  , validateSymbol = __webpack_require__(24)
	
	  , create = Object.create, defineProperties = Object.defineProperties
	  , defineProperty = Object.defineProperty, objPrototype = Object.prototype
	  , NativeSymbol, SymbolPolyfill, HiddenSymbol, globalSymbols = create(null);
	
	if (typeof Symbol === 'function') NativeSymbol = Symbol;
	
	var generateName = (function () {
		var created = create(null);
		return function (desc) {
			var postfix = 0, name, ie11BugWorkaround;
			while (created[desc + (postfix || '')]) ++postfix;
			desc += (postfix || '');
			created[desc] = true;
			name = '@@' + desc;
			defineProperty(objPrototype, name, d.gs(null, function (value) {
				// For IE11 issue see:
				// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
				//    ie11-broken-getters-on-dom-objects
				// https://github.com/medikoo/es6-symbol/issues/12
				if (ie11BugWorkaround) return;
				ie11BugWorkaround = true;
				defineProperty(this, name, d(value));
				ie11BugWorkaround = false;
			}));
			return name;
		};
	}());
	
	// Internal constructor (not one exposed) for creating Symbol instances.
	// This one is used to ensure that `someSymbol instanceof Symbol` always return false
	HiddenSymbol = function Symbol(description) {
		if (this instanceof HiddenSymbol) throw new TypeError('TypeError: Symbol is not a constructor');
		return SymbolPolyfill(description);
	};
	
	// Exposed `Symbol` constructor
	// (returns instances of HiddenSymbol)
	module.exports = SymbolPolyfill = function Symbol(description) {
		var symbol;
		if (this instanceof Symbol) throw new TypeError('TypeError: Symbol is not a constructor');
		symbol = create(HiddenSymbol.prototype);
		description = (description === undefined ? '' : String(description));
		return defineProperties(symbol, {
			__description__: d('', description),
			__name__: d('', generateName(description))
		});
	};
	defineProperties(SymbolPolyfill, {
		for: d(function (key) {
			if (globalSymbols[key]) return globalSymbols[key];
			return (globalSymbols[key] = SymbolPolyfill(String(key)));
		}),
		keyFor: d(function (s) {
			var key;
			validateSymbol(s);
			for (key in globalSymbols) if (globalSymbols[key] === s) return key;
		}),
	
		// If there's native implementation of given symbol, let's fallback to it
		// to ensure proper interoperability with other native functions e.g. Array.from
		hasInstance: d('', (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill('hasInstance')),
		isConcatSpreadable: d('', (NativeSymbol && NativeSymbol.isConcatSpreadable) ||
			SymbolPolyfill('isConcatSpreadable')),
		iterator: d('', (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill('iterator')),
		match: d('', (NativeSymbol && NativeSymbol.match) || SymbolPolyfill('match')),
		replace: d('', (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill('replace')),
		search: d('', (NativeSymbol && NativeSymbol.search) || SymbolPolyfill('search')),
		species: d('', (NativeSymbol && NativeSymbol.species) || SymbolPolyfill('species')),
		split: d('', (NativeSymbol && NativeSymbol.split) || SymbolPolyfill('split')),
		toPrimitive: d('', (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill('toPrimitive')),
		toStringTag: d('', (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill('toStringTag')),
		unscopables: d('', (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill('unscopables'))
	});
	
	// Internal tweaks for real symbol producer
	defineProperties(HiddenSymbol.prototype, {
		constructor: d(SymbolPolyfill),
		toString: d('', function () { return this.__name__; })
	});
	
	// Proper implementation of methods exposed on Symbol.prototype
	// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
	defineProperties(SymbolPolyfill.prototype, {
		toString: d(function () { return 'Symbol (' + validateSymbol(this).__description__ + ')'; }),
		valueOf: d(function () { return validateSymbol(this); })
	});
	defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive, d('',
		function () { return validateSymbol(this); }));
	defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d('c', 'Symbol'));
	
	// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
	defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
		d('c', SymbolPolyfill.prototype[SymbolPolyfill.toStringTag]));
	
	// Note: It's important to define `toPrimitive` as last one, as some implementations
	// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
	// And that may invoke error in definition flow:
	// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
	defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
		d('c', SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive]));


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign        = __webpack_require__(12)
	  , normalizeOpts = __webpack_require__(19)
	  , isCallable    = __webpack_require__(20)
	  , contains      = __webpack_require__(21)
	
	  , d;
	
	d = module.exports = function (dscr, value/*, options*/) {
		var c, e, w, options, desc;
		if ((arguments.length < 2) || (typeof dscr !== 'string')) {
			options = value;
			value = dscr;
			dscr = null;
		} else {
			options = arguments[2];
		}
		if (dscr == null) {
			c = w = true;
			e = false;
		} else {
			c = contains.call(dscr, 'c');
			e = contains.call(dscr, 'e');
			w = contains.call(dscr, 'w');
		}
	
		desc = { value: value, configurable: c, enumerable: e, writable: w };
		return !options ? desc : assign(normalizeOpts(options), desc);
	};
	
	d.gs = function (dscr, get, set/*, options*/) {
		var c, e, options, desc;
		if (typeof dscr !== 'string') {
			options = set;
			set = get;
			get = dscr;
			dscr = null;
		} else {
			options = arguments[3];
		}
		if (get == null) {
			get = undefined;
		} else if (!isCallable(get)) {
			options = get;
			get = set = undefined;
		} else if (set == null) {
			set = undefined;
		} else if (!isCallable(set)) {
			options = set;
			set = undefined;
		}
		if (dscr == null) {
			c = true;
			e = false;
		} else {
			c = contains.call(dscr, 'c');
			e = contains.call(dscr, 'e');
		}
	
		desc = { get: get, set: set, configurable: c, enumerable: e };
		return !options ? desc : assign(normalizeOpts(options), desc);
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(13)()
		? Object.assign
		: __webpack_require__(14);


/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
		var assign = Object.assign, obj;
		if (typeof assign !== 'function') return false;
		obj = { foo: 'raz' };
		assign(obj, { bar: 'dwa' }, { trzy: 'trzy' });
		return (obj.foo + obj.bar + obj.trzy) === 'razdwatrzy';
	};


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys  = __webpack_require__(15)
	  , value = __webpack_require__(18)
	
	  , max = Math.max;
	
	module.exports = function (dest, src/*, …srcn*/) {
		var error, i, l = max(arguments.length, 2), assign;
		dest = Object(value(dest));
		assign = function (key) {
			try { dest[key] = src[key]; } catch (e) {
				if (!error) error = e;
			}
		};
		for (i = 1; i < l; ++i) {
			src = arguments[i];
			keys(src).forEach(assign);
		}
		if (error !== undefined) throw error;
		return dest;
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(16)()
		? Object.keys
		: __webpack_require__(17);


/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
		try {
			Object.keys('primitive');
			return true;
		} catch (e) { return false; }
	};


/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	var keys = Object.keys;
	
	module.exports = function (object) {
		return keys(object == null ? object : Object(object));
	};


/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (value) {
		if (value == null) throw new TypeError("Cannot use null or undefined");
		return value;
	};


/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';
	
	var forEach = Array.prototype.forEach, create = Object.create;
	
	var process = function (src, obj) {
		var key;
		for (key in src) obj[key] = src[key];
	};
	
	module.exports = function (options/*, …options*/) {
		var result = create(null);
		forEach.call(arguments, function (options) {
			if (options == null) return;
			process(Object(options), result);
		});
		return result;
	};


/***/ },
/* 20 */
/***/ function(module, exports) {

	// Deprecated
	
	'use strict';
	
	module.exports = function (obj) { return typeof obj === 'function'; };


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(22)()
		? String.prototype.contains
		: __webpack_require__(23);


/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	var str = 'razdwatrzy';
	
	module.exports = function () {
		if (typeof str.contains !== 'function') return false;
		return ((str.contains('dwa') === true) && (str.contains('foo') === false));
	};


/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';
	
	var indexOf = String.prototype.indexOf;
	
	module.exports = function (searchString/*, position*/) {
		return indexOf.call(this, searchString, arguments[1]) > -1;
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isSymbol = __webpack_require__(25);
	
	module.exports = function (value) {
		if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
		return value;
	};


/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (x) {
		return (x && ((typeof x === 'symbol') || (x['@@toStringTag'] === 'Symbol'))) || false;
	};


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var consts = __webpack_require__(7);
	
	function hydrate(data, cleaned) {
	  cleaned.forEach(function (path) {
	    var last = path.pop();
	    var obj = path.reduce(function (obj_, attr) {
	      return obj_ ? obj_[attr] : null;
	    }, data);
	    if (!obj || !obj[last]) {
	      return;
	    }
	    var replace = {};
	    replace[consts.name] = obj[last].name;
	    replace[consts.type] = obj[last].type;
	    replace[consts.meta] = obj[last].meta;
	    replace[consts.inspected] = false;
	    obj[last] = replace;
	  });
	}
	
	module.exports = hydrate;

/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * Get a enhanced/artificial type string based on the object instance
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function getPropType(data) {
	  if (!data) {
	    return null;
	  }
	  var type = typeof data === 'undefined' ? 'undefined' : _typeof(data);
	
	  if (type === 'object') {
	    if (data._reactFragment) {
	      return 'react_fragment';
	    }
	    if (Array.isArray(data)) {
	      return 'array';
	    }
	    if (ArrayBuffer.isView(data)) {
	      if (data instanceof DataView) {
	        return 'data_view';
	      }
	      return 'typed_array';
	    }
	    if (data instanceof ArrayBuffer) {
	      return 'array_buffer';
	    }
	    if (typeof data[Symbol.iterator] === 'function') {
	      return 'iterator';
	    }
	    if (Object.prototype.toString.call(data) === '[object Date]') {
	      return 'date';
	    }
	  }
	
	  return type;
	}
	
	/**
	 * Generate the dehydrated metadata for complex object instances
	 */
	function createDehydrated(type, data, cleaned, path) {
	  var meta = {};
	
	  if (type === 'array' || type === 'typed_array') {
	    meta.length = data.length;
	  }
	  if (type === 'iterator' || type === 'typed_array') {
	    meta.readOnly = true;
	  }
	
	  cleaned.push(path);
	
	  return {
	    type: type,
	    meta: meta,
	    name: !data.constructor || data.constructor.name === 'Object' ? '' : data.constructor.name
	  };
	}
	
	/**
	 * Strip out complex data (instances, functions, and data nested > 2 levels
	 * deep). The paths of the stripped out objects are appended to the `cleaned`
	 * list. On the other side of the barrier, the cleaned list is used to
	 * "re-hydrate" the cleaned representation into an object with symbols as
	 * attributes, so that a sanitized object can be distinguished from a normal
	 * object.
	 *
	 * Input: {"some": {"attr": fn()}, "other": AnInstance}
	 * Output: {
	 *   "some": {
	 *     "attr": {"name": the fn.name, type: "function"}
	 *   },
	 *   "other": {
	 *     "name": "AnInstance",
	 *     "type": "object",
	 *   },
	 * }
	 * and cleaned = [["some", "attr"], ["other"]]
	 */
	function dehydrate(data, cleaned) {
	  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	
	  var type = getPropType(data);
	
	  switch (type) {
	
	    case 'function':
	      cleaned.push(path);
	      return {
	        name: data.name,
	        type: 'function'
	      };
	
	    case 'string':
	      return data.length <= 500 ? data : data.slice(0, 500) + '...';
	
	    // We have to do this assignment b/c Flow doesn't think "symbol" is
	    // something typeof would return. Error 'unexpected predicate "symbol"'
	    case 'symbol':
	      cleaned.push(path);
	      return {
	        type: 'symbol',
	        name: data.toString()
	      };
	
	    // React Fragments error if you try to inspect them.
	    case 'react_fragment':
	      return 'A React Fragment';
	
	    // ArrayBuffers error if you try to inspect them.
	    case 'array_buffer':
	    case 'data_view':
	      cleaned.push(path);
	      return {
	        type: type,
	        name: type === 'data_view' ? 'DataView' : 'ArrayBuffer',
	        meta: {
	          length: data.byteLength,
	          uninspectable: true
	        }
	      };
	
	    case 'array':
	      if (level > 2) {
	        return createDehydrated(type, data, cleaned, path);
	      }
	      return data.map(function (item, i) {
	        return dehydrate(item, cleaned, path.concat([i]), level + 1);
	      });
	
	    case 'typed_array':
	    case 'iterator':
	      return createDehydrated(type, data, cleaned, path);
	    case 'date':
	      cleaned.push(path);
	      return {
	        name: data.toString(),
	        type: 'date',
	        meta: {
	          uninspectable: true
	        }
	      };
	    case 'object':
	      if (level > 2 || data.constructor && typeof data.constructor === 'function' && data.constructor.name !== 'Object') {
	        return createDehydrated(type, data, cleaned, path);
	      } else {
	
	        var res = {};
	        for (var name in data) {
	          res[name] = dehydrate(data[name], cleaned, path.concat([name]), level + 1);
	        }
	        return res;
	      }
	
	    default:
	      return data;
	  }
	}
	
	module.exports = dehydrate;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performanceNow
	 * @typechecks
	 */
	
	'use strict';
	
	var performance = __webpack_require__(29);
	
	var performanceNow;
	
	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (performance.now) {
	  performanceNow = function () {
	    return performance.now();
	  };
	} else {
	  performanceNow = function () {
	    return Date.now();
	  };
	}
	
	module.exports = performanceNow;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performance
	 * @typechecks
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var performance;
	
	if (ExecutionEnvironment.canUseDOM) {
	  performance = window.performance || window.msPerformance || window.webkitPerformance;
	}
	
	module.exports = performance || {};

/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * NOTE: This file cannot `require` any other modules. We `.toString()` the
	 *       function in some places and inject the source into the page.
	 */
	function installGlobalHook(window) {
	  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
	    return;
	  }
	  function detectReactBuildType(renderer) {
	    try {
	      var toString = Function.prototype.toString;
	      if (typeof renderer.version === 'string') {
	        // React DOM Fiber (16+)
	        if (renderer.bundleType > 0) {
	          // This is not a production build.
	          // We are currently only using 0 (PROD) and 1 (DEV)
	          // but might add 2 (PROFILE) in the future.
	          return 'development';
	        }
	        // The above should cover envification, but we should still make sure
	        // that the bundle code has been uglified.
	        var findFiberCode = toString.call(renderer.findFiberByHostInstance);
	        // Filter out bad results (if that is even possible):
	        if (findFiberCode.indexOf('function') !== 0) {
	          // Hope for the best if we're not sure.
	          return 'production';
	        }
	
	        // By now we know that it's envified--but what if it's not minified?
	        // This can be bad too, as it means DEV code is still there.
	
	        // FIXME: this is fragile!
	        // We should replace this check with check on a specially passed
	        // function. This also doesn't detect lack of dead code elimination
	        // (although this is not a problem since flat bundles).
	        if (findFiberCode.indexOf('getClosestInstanceFromNode') !== -1) {
	          return 'unminified';
	        }
	
	        // We're good.
	        return 'production';
	      }
	      if (renderer.Mount && renderer.Mount._renderNewRootComponent) {
	        // React DOM Stack
	        var renderRootCode = toString.call(renderer.Mount._renderNewRootComponent);
	        // Filter out bad results (if that is even possible):
	        if (renderRootCode.indexOf('function') !== 0) {
	          // Hope for the best if we're not sure.
	          return 'production';
	        }
	        // Check for React DOM Stack < 15.1.0 in development.
	        // If it contains "storedMeasure" call, it's wrapped in ReactPerf (DEV only).
	        // This would be true even if it's minified, as method name still matches.
	        if (renderRootCode.indexOf('storedMeasure') !== -1) {
	          return 'development';
	        }
	        // For other versions (and configurations) it's not so easy.
	        // Let's quickly exclude proper production builds.
	        // If it contains a warning message, it's either a DEV build,
	        // or an PROD build without proper dead code elimination.
	        if (renderRootCode.indexOf('should be a pure function') !== -1) {
	          // Now how do we tell a DEV build from a bad PROD build?
	          // If we see NODE_ENV, we're going to assume this is a dev build
	          // because most likely it is referring to an empty shim.
	          if (renderRootCode.indexOf('NODE_ENV') !== -1) {
	            return 'development';
	          }
	          // If we see "development", we're dealing with an envified DEV build
	          // (such as the official React DEV UMD).
	          if (renderRootCode.indexOf('development') !== -1) {
	            return 'development';
	          }
	          // I've seen process.env.NODE_ENV !== 'production' being smartly
	          // replaced by `true` in DEV by Webpack. I don't know how that
	          // works but we can safely guard against it because `true` was
	          // never used in the function source since it was written.
	          if (renderRootCode.indexOf('true') !== -1) {
	            return 'development';
	          }
	          // By now either it is a production build that has not been minified,
	          // or (worse) this is a minified development build using non-standard
	          // environment (e.g. "staging"). We're going to look at whether
	          // the function argument name is mangled:
	          if (
	          // 0.13 to 15
	          renderRootCode.indexOf('nextElement') !== -1 ||
	          // 0.12
	          renderRootCode.indexOf('nextComponent') !== -1) {
	            // We can't be certain whether this is a development build or not,
	            // but it is definitely unminified.
	            return 'unminified';
	          } else {
	            // This is likely a minified development build.
	            return 'development';
	          }
	        }
	        // By now we know that it's envified and dead code elimination worked,
	        // but what if it's still not minified? (Is this even possible?)
	        // Let's check matches for the first argument name.
	        if (
	        // 0.13 to 15
	        renderRootCode.indexOf('nextElement') !== -1 ||
	        // 0.12
	        renderRootCode.indexOf('nextComponent') !== -1) {
	          return 'unminified';
	        }
	        // Seems like we're using the production version.
	        // Now let's check if we're still on 0.14 or lower:
	        if (renderRootCode.indexOf('._registerComponent') !== -1) {
	          // TODO: we can remove the condition above once 16
	          // is older than a year. Since this branch only runs
	          // for Stack, we can flip it completely when Stack
	          // is old enough. The branch for Fiber is above,
	          // and it can check renderer.version directly.
	          return 'outdated';
	        }
	        // We're all good.
	        return 'production';
	      }
	    } catch (err) {
	      // Weird environments may exist.
	      // This code needs a higher fault tolerance
	      // because it runs even with closed DevTools.
	      // TODO: should we catch errors in all injected code, and not just this part?
	    }
	    return 'production';
	  }
	  var hook = {
	    // Shared between Stack and Fiber:
	    _renderers: {},
	    helpers: {},
	    inject: function inject(renderer) {
	      var id = Math.random().toString(16).slice(2);
	      hook._renderers[id] = renderer;
	      var reactBuildType = detectReactBuildType(renderer);
	      hook.emit('renderer', { id: id, renderer: renderer, reactBuildType: reactBuildType });
	      return id;
	    },
	    _listeners: {},
	    sub: function sub(evt, fn) {
	      hook.on(evt, fn);
	      return function () {
	        return hook.off(evt, fn);
	      };
	    },
	    on: function on(evt, fn) {
	      if (!hook._listeners[evt]) {
	        hook._listeners[evt] = [];
	      }
	      hook._listeners[evt].push(fn);
	    },
	    off: function off(evt, fn) {
	      if (!hook._listeners[evt]) {
	        return;
	      }
	      var ix = hook._listeners[evt].indexOf(fn);
	      if (ix !== -1) {
	        hook._listeners[evt].splice(ix, 1);
	      }
	      if (!hook._listeners[evt].length) {
	        hook._listeners[evt] = null;
	      }
	    },
	    emit: function emit(evt, data) {
	      if (hook._listeners[evt]) {
	        hook._listeners[evt].map(function (fn) {
	          return fn(data);
	        });
	      }
	    },
	    // Fiber-only:
	    supportsFiber: true,
	    _fiberRoots: {},
	    getFiberRoots: function getFiberRoots(rendererID) {
	      var roots = hook._fiberRoots;
	      if (!roots[rendererID]) {
	        roots[rendererID] = new Set();
	      }
	      return roots[rendererID];
	    },
	
	    onCommitFiberUnmount: function onCommitFiberUnmount(rendererID, fiber) {
	      // TODO: can we use hook for roots too?
	      if (hook.helpers[rendererID]) {
	        hook.helpers[rendererID].handleCommitFiberUnmount(fiber);
	      }
	    },
	    onCommitFiberRoot: function onCommitFiberRoot(rendererID, root) {
	      var mountedRoots = hook.getFiberRoots(rendererID);
	      var current = root.current;
	      var isKnownRoot = mountedRoots.has(root);
	      var isUnmounting = current.memoizedState == null || current.memoizedState.element == null;
	      // Keep track of mounted roots so we can hydrate when DevTools connect.
	      if (!isKnownRoot && !isUnmounting) {
	        mountedRoots.add(root);
	      } else if (isKnownRoot && isUnmounting) {
	        mountedRoots.delete(root);
	      }
	      if (hook.helpers[rendererID]) {
	        hook.helpers[rendererID].handleCommitFiberRoot(root);
	      }
	    }
	  };
	  Object.defineProperty(window, '__REACT_DEVTOOLS_GLOBAL_HOOK__', {
	    value: hook
	  });
	}
	
	module.exports = installGlobalHook;

/***/ },
/* 32 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * NOTE: This file cannot `require` any other modules. We `.toString()` the
	 *       function in some places and inject the source into the page.
	 * Also do not declare any variables in top level scope!
	 */
	
	function installRelayHook(window) {
	  var performance = window.performance;
	  var performanceNow;
	  if (performance && typeof performance.now === 'function') {
	    performanceNow = function performanceNow() {
	      return performance.now();
	    };
	  } else {
	    performanceNow = function performanceNow() {
	      return Date.now();
	    };
	  }
	
	  var TEXT_CHUNK_LENGTH = 500;
	
	  var hook = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
	  if (!hook) {
	    return;
	  }
	
	  function decorate(obj, attr, fn) {
	    var old = obj[attr];
	    obj[attr] = function () {
	      var res = old.apply(this, arguments);
	      fn.apply(this, arguments);
	      return res;
	    };
	  }
	
	  var _eventQueue = [];
	  var _listener = null;
	  function emit(name, data) {
	    _eventQueue.push({ name: name, data: data });
	    if (_listener) {
	      _listener(name, data);
	    }
	  }
	
	  function setRequestListener(listener) {
	    if (_listener) {
	      throw new Error('Relay Devtools: Called only call setRequestListener once.');
	    }
	    _listener = listener;
	    _eventQueue.forEach(function (_ref) {
	      var name = _ref.name,
	          data = _ref.data;
	
	      listener(name, data);
	    });
	
	    return function () {
	      _listener = null;
	    };
	  }
	
	  function recordRequest(type, start, request, requestNumber) {
	    var id = Math.random().toString(16).substr(2);
	    request.then(function (response) {
	      emit('relay:success', {
	        id: id,
	        end: performanceNow(),
	        response: response.response
	      });
	    }, function (error) {
	      emit('relay:failure', {
	        id: id,
	        end: performanceNow(),
	        error: error
	      });
	    });
	    var textChunks = [];
	    var text = request.getQueryString();
	    while (text.length > 0) {
	      textChunks.push(text.substr(0, TEXT_CHUNK_LENGTH));
	      text = text.substr(TEXT_CHUNK_LENGTH);
	    }
	    return {
	      id: id,
	      name: request.getDebugName(),
	      requestNumber: requestNumber,
	      start: start,
	      text: textChunks,
	      type: type,
	      variables: request.getVariables()
	    };
	  }
	
	  var requestNumber = 0;
	
	  function instrumentRelayRequests(relayInternals) {
	    var NetworkLayer = relayInternals.NetworkLayer;
	
	    decorate(NetworkLayer, 'sendMutation', function (mutation) {
	      requestNumber++;
	      emit('relay:pending', [recordRequest('mutation', performanceNow(), mutation, requestNumber)]);
	    });
	
	    decorate(NetworkLayer, 'sendQueries', function (queries) {
	      requestNumber++;
	      var start = performanceNow();
	      emit('relay:pending', queries.map(function (query) {
	        return recordRequest('query', start, query, requestNumber);
	      }));
	    });
	
	    var instrumented = {};
	    for (var key in relayInternals) {
	      if (relayInternals.hasOwnProperty(key)) {
	        instrumented[key] = relayInternals[key];
	      }
	    }
	    instrumented.setRequestListener = setRequestListener;
	    return instrumented;
	  }
	
	  var _relayInternals = null;
	  Object.defineProperty(hook, '_relayInternals', {
	    configurable: true,
	    set: function set(relayInternals) {
	      _relayInternals = instrumentRelayRequests(relayInternals);
	    },
	    get: function get() {
	      return _relayInternals;
	    }
	  });
	}
	
	module.exports = installRelayHook;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var setupBackend = __webpack_require__(34);
	
	module.exports = function (hook, agent) {
	  var subs = [hook.sub('renderer-attached', function (_ref) {
	    var id = _ref.id,
	        renderer = _ref.renderer,
	        helpers = _ref.helpers;
	
	    agent.setReactInternals(id, helpers);
	    helpers.walkTree(agent.onMounted.bind(agent, id), agent.addRoot.bind(agent, id));
	  }), hook.sub('root', function (_ref2) {
	    var renderer = _ref2.renderer,
	        internalInstance = _ref2.internalInstance;
	    return agent.addRoot(renderer, internalInstance);
	  }), hook.sub('mount', function (_ref3) {
	    var renderer = _ref3.renderer,
	        internalInstance = _ref3.internalInstance,
	        data = _ref3.data;
	    return agent.onMounted(renderer, internalInstance, data);
	  }), hook.sub('update', function (_ref4) {
	    var renderer = _ref4.renderer,
	        internalInstance = _ref4.internalInstance,
	        data = _ref4.data;
	    return agent.onUpdated(internalInstance, data);
	  }), hook.sub('unmount', function (_ref5) {
	    var renderer = _ref5.renderer,
	        internalInstance = _ref5.internalInstance;
	    return agent.onUnmounted(internalInstance);
	  })];
	
	  var success = setupBackend(hook);
	  if (!success) {
	    return;
	  }
	
	  hook.emit('react-devtools', agent);
	  hook.reactDevtoolsAgent = agent;
	  agent.on('shutdown', function () {
	    subs.forEach(function (fn) {
	      return fn();
	    });
	    hook.reactDevtoolsAgent = null;
	  });
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 *
	 * This is the chrome devtools
	 *
	 * 1. Devtools sets the __REACT_DEVTOOLS_GLOBAL_HOOK__ global.
	 * 2. React (if present) calls .inject() with the internal renderer
	 * 3. Devtools sees the renderer, and then adds this backend, along with the Agent
	 *    and whatever else is needed.
	 * 4. The agent then calls `.emit('react-devtools', agent)`
	 *
	 * Now things are hooked up.
	 *
	 * When devtools closes, it calls `cleanup()` to remove the listeners
	 * and any overhead caused by the backend.
	 */
	'use strict';
	
	var attachRenderer = __webpack_require__(35);
	
	module.exports = function setupBackend(hook) {
	  var oldReact = window.React && window.React.__internals;
	  if (oldReact && Object.keys(hook._renderers).length === 0) {
	    hook.inject(oldReact);
	  }
	
	  for (var rid in hook._renderers) {
	    hook.helpers[rid] = attachRenderer(hook, rid, hook._renderers[rid]);
	    hook.emit('renderer-attached', { id: rid, renderer: hook._renderers[rid], helpers: hook.helpers[rid] });
	  }
	
	  hook.on('renderer', function (_ref) {
	    var id = _ref.id,
	        renderer = _ref.renderer;
	
	    hook.helpers[id] = attachRenderer(hook, id, renderer);
	    hook.emit('renderer-attached', { id: id, renderer: renderer, helpers: hook.helpers[id] });
	  });
	
	  var shutdown = function shutdown() {
	    for (var id in hook.helpers) {
	      hook.helpers[id].cleanup();
	    }
	    hook.off('shutdown', shutdown);
	  };
	  hook.on('shutdown', shutdown);
	
	  return true;
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var getData = __webpack_require__(36);
	var getData012 = __webpack_require__(39);
	var attachRendererFiber = __webpack_require__(40);
	
	/**
	 * This takes care of patching the renderer to emit events on the global
	 * `Hook`. The returned object has a `.cleanup` method to un-patch everything.
	 */
	function attachRenderer(hook, rid, renderer) {
	  var rootNodeIDMap = new Map();
	  var extras = {};
	  // Before 0.13 there was no Reconciler, so we patch Component.Mixin
	  var isPre013 = !renderer.Reconciler;
	
	  // React Fiber
	  if (typeof renderer.findFiberByHostInstance === 'function') {
	    return attachRendererFiber(hook, rid, renderer);
	  }
	
	  // React Native
	  if (renderer.Mount.findNodeHandle && renderer.Mount.nativeTagToRootNodeID) {
	    extras.getNativeFromReactElement = function (component) {
	      return renderer.Mount.findNodeHandle(component);
	    };
	
	    extras.getReactElementFromNative = function (nativeTag) {
	      var id = renderer.Mount.nativeTagToRootNodeID(nativeTag);
	      return rootNodeIDMap.get(id);
	    };
	    // React DOM 15+
	  } else if (renderer.ComponentTree) {
	    extras.getNativeFromReactElement = function (component) {
	      return renderer.ComponentTree.getNodeFromInstance(component);
	    };
	
	    extras.getReactElementFromNative = function (node) {
	      return renderer.ComponentTree.getClosestInstanceFromNode(node);
	    };
	    // React DOM
	  } else if (renderer.Mount.getID && renderer.Mount.getNode) {
	    extras.getNativeFromReactElement = function (component) {
	      try {
	        return renderer.Mount.getNode(component._rootNodeID);
	      } catch (e) {
	        return undefined;
	      }
	    };
	
	    extras.getReactElementFromNative = function (node) {
	      var id = renderer.Mount.getID(node);
	      while (node && node.parentNode && !id) {
	        node = node.parentNode;
	        id = renderer.Mount.getID(node);
	      }
	      return rootNodeIDMap.get(id);
	    };
	  } else {
	    console.warn('Unknown react version (does not have getID), probably an unshimmed React Native');
	  }
	
	  var oldMethods;
	  var oldRenderComponent;
	  var oldRenderRoot;
	
	  // React DOM
	  if (renderer.Mount._renderNewRootComponent) {
	    oldRenderRoot = decorateResult(renderer.Mount, '_renderNewRootComponent', function (internalInstance) {
	      hook.emit('root', { renderer: rid, internalInstance: internalInstance });
	    });
	    // React Native
	  } else if (renderer.Mount.renderComponent) {
	    oldRenderComponent = decorateResult(renderer.Mount, 'renderComponent', function (internalInstance) {
	      hook.emit('root', { renderer: rid, internalInstance: internalInstance._reactInternalInstance });
	    });
	  }
	
	  if (renderer.Component) {
	    console.error('You are using a version of React with limited support in this version of the devtools.\nPlease upgrade to use at least 0.13, or you can downgrade to use the old version of the devtools:\ninstructions here https://github.com/facebook/react-devtools/tree/devtools-next#how-do-i-use-this-for-react--013');
	    // 0.11 - 0.12
	    // $FlowFixMe renderer.Component is not "possibly undefined"
	    oldMethods = decorateMany(renderer.Component.Mixin, {
	      mountComponent: function mountComponent() {
	        var _this = this;
	
	        rootNodeIDMap.set(this._rootNodeID, this);
	        // FIXME DOMComponent calls Component.Mixin, and sets up the
	        // `children` *after* that call, meaning we don't have access to the
	        // children at this point. Maybe we should find something else to shim
	        // (do we have access to DOMComponent here?) so that we don't have to
	        // setTimeout.
	        setTimeout(function () {
	          hook.emit('mount', { internalInstance: _this, data: getData012(_this), renderer: rid });
	        }, 0);
	      },
	      updateComponent: function updateComponent() {
	        var _this2 = this;
	
	        setTimeout(function () {
	          hook.emit('update', { internalInstance: _this2, data: getData012(_this2), renderer: rid });
	        }, 0);
	      },
	      unmountComponent: function unmountComponent() {
	        hook.emit('unmount', { internalInstance: this, renderer: rid });
	        rootNodeIDMap.delete(this._rootNodeID, this);
	      }
	    });
	  } else if (renderer.Reconciler) {
	    oldMethods = decorateMany(renderer.Reconciler, {
	      mountComponent: function mountComponent(internalInstance, rootID, transaction, context) {
	        var data = getData(internalInstance);
	        rootNodeIDMap.set(internalInstance._rootNodeID, internalInstance);
	        hook.emit('mount', { internalInstance: internalInstance, data: data, renderer: rid });
	      },
	      performUpdateIfNecessary: function performUpdateIfNecessary(internalInstance, nextChild, transaction, context) {
	        hook.emit('update', { internalInstance: internalInstance, data: getData(internalInstance), renderer: rid });
	      },
	      receiveComponent: function receiveComponent(internalInstance, nextChild, transaction, context) {
	        hook.emit('update', { internalInstance: internalInstance, data: getData(internalInstance), renderer: rid });
	      },
	      unmountComponent: function unmountComponent(internalInstance) {
	        hook.emit('unmount', { internalInstance: internalInstance, renderer: rid });
	        rootNodeIDMap.delete(internalInstance._rootNodeID, internalInstance);
	      }
	    });
	  }
	
	  extras.walkTree = function (visit, visitRoot) {
	    var onMount = function onMount(component, data) {
	      rootNodeIDMap.set(component._rootNodeID, component);
	      visit(component, data);
	    };
	    walkRoots(renderer.Mount._instancesByReactRootID || renderer.Mount._instancesByContainerID, onMount, visitRoot, isPre013);
	  };
	
	  extras.cleanup = function () {
	    if (oldMethods) {
	      if (renderer.Component) {
	        restoreMany(renderer.Component.Mixin, oldMethods);
	      } else {
	        restoreMany(renderer.Reconciler, oldMethods);
	      }
	    }
	    if (oldRenderRoot) {
	      renderer.Mount._renderNewRootComponent = oldRenderRoot;
	    }
	    if (oldRenderComponent) {
	      renderer.Mount.renderComponent = oldRenderComponent;
	    }
	    oldMethods = null;
	    oldRenderRoot = null;
	    oldRenderComponent = null;
	  };
	
	  return extras;
	}
	
	function walkRoots(roots, onMount, onRoot, isPre013) {
	  for (var name in roots) {
	    walkNode(roots[name], onMount, isPre013);
	    onRoot(roots[name]);
	  }
	}
	
	function walkNode(internalInstance, onMount, isPre013) {
	  var data = isPre013 ? getData012(internalInstance) : getData(internalInstance);
	  if (data.children && Array.isArray(data.children)) {
	    data.children.forEach(function (child) {
	      return walkNode(child, onMount, isPre013);
	    });
	  }
	  onMount(internalInstance, data);
	}
	
	function decorateResult(obj, attr, fn) {
	  var old = obj[attr];
	  obj[attr] = function (instance) {
	    var res = old.apply(this, arguments);
	    fn(res);
	    return res;
	  };
	  return old;
	}
	
	function decorate(obj, attr, fn) {
	  var old = obj[attr];
	  obj[attr] = function (instance) {
	    var res = old.apply(this, arguments);
	    fn.apply(this, arguments);
	    return res;
	  };
	  return old;
	}
	
	function decorateMany(source, fns) {
	  var olds = {};
	  for (var name in fns) {
	    olds[name] = decorate(source, name, fns[name]);
	  }
	  return olds;
	}
	
	function restoreMany(source, olds) {
	  for (var name in olds) {
	    source[name] = olds[name];
	  }
	}
	
	module.exports = attachRenderer;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var copyWithSet = __webpack_require__(37);
	var getDisplayName = __webpack_require__(38);
	
	/**
	 * Convert a react internal instance to a sanitized data object.
	 */
	function getData(internalInstance) {
	  var children = null;
	  var props = null;
	  var state = null;
	  var context = null;
	  var updater = null;
	  var name = null;
	  var type = null;
	  var key = null;
	  var ref = null;
	  var source = null;
	  var text = null;
	  var publicInstance = null;
	  var nodeType = 'Native';
	  // If the parent is a native node without rendered children, but with
	  // multiple string children, then the `element` that gets passed in here is
	  // a plain value -- a string or number.
	  if ((typeof internalInstance === 'undefined' ? 'undefined' : _typeof(internalInstance)) !== 'object') {
	    nodeType = 'Text';
	    text = internalInstance + '';
	  } else if (internalInstance._currentElement === null || internalInstance._currentElement === false) {
	    nodeType = 'Empty';
	  } else if (internalInstance._renderedComponent) {
	    nodeType = 'NativeWrapper';
	    children = [internalInstance._renderedComponent];
	    props = internalInstance._instance.props;
	    state = internalInstance._instance.state;
	    context = internalInstance._instance.context;
	    if (context && Object.keys(context).length === 0) {
	      context = null;
	    }
	  } else if (internalInstance._renderedChildren) {
	    children = childrenList(internalInstance._renderedChildren);
	  } else if (internalInstance._currentElement && internalInstance._currentElement.props) {
	    // This is a native node without rendered children -- meaning the children
	    // prop is just a string or (in the case of the <option>) a list of
	    // strings & numbers.
	    children = internalInstance._currentElement.props.children;
	  }
	
	  if (!props && internalInstance._currentElement && internalInstance._currentElement.props) {
	    props = internalInstance._currentElement.props;
	  }
	
	  // != used deliberately here to catch undefined and null
	  if (internalInstance._currentElement != null) {
	    type = internalInstance._currentElement.type;
	    if (internalInstance._currentElement.key) {
	      key = String(internalInstance._currentElement.key);
	    }
	    source = internalInstance._currentElement._source;
	    ref = internalInstance._currentElement.ref;
	    if (typeof type === 'string') {
	      name = type;
	      if (internalInstance._nativeNode != null) {
	        publicInstance = internalInstance._nativeNode;
	      }
	      if (internalInstance._hostNode != null) {
	        publicInstance = internalInstance._hostNode;
	      }
	    } else if (typeof type === 'function') {
	      nodeType = 'Composite';
	      name = getDisplayName(type);
	      // 0.14 top-level wrapper
	      // TODO(jared): The backend should just act as if these don't exist.
	      if (internalInstance._renderedComponent && (internalInstance._currentElement.props === internalInstance._renderedComponent._currentElement || internalInstance._currentElement.type.isReactTopLevelWrapper)) {
	        nodeType = 'Wrapper';
	      }
	      if (name === null) {
	        name = 'No display name';
	      }
	    } else if (typeof internalInstance._stringText === 'string') {
	      nodeType = 'Text';
	      text = internalInstance._stringText;
	    } else {
	      name = getDisplayName(type);
	    }
	  }
	
	  if (internalInstance._instance) {
	    var inst = internalInstance._instance;
	    updater = {
	      setState: inst.setState && inst.setState.bind(inst),
	      forceUpdate: inst.forceUpdate && inst.forceUpdate.bind(inst),
	      setInProps: inst.forceUpdate && setInProps.bind(null, internalInstance),
	      setInState: inst.forceUpdate && setInState.bind(null, inst),
	      setInContext: inst.forceUpdate && setInContext.bind(null, inst)
	    };
	    if (typeof type === 'function') {
	      publicInstance = inst;
	    }
	
	    // TODO: React ART currently falls in this bucket, but this doesn't
	    // actually make sense and we should clean this up after stabilizing our
	    // API for backends
	    if (inst._renderedChildren) {
	      children = childrenList(inst._renderedChildren);
	    }
	  }
	
	  return {
	    nodeType: nodeType,
	    type: type,
	    key: key,
	    ref: ref,
	    source: source,
	    name: name,
	    props: props,
	    state: state,
	    context: context,
	    children: children,
	    text: text,
	    updater: updater,
	    publicInstance: publicInstance
	  };
	}
	
	function setInProps(internalInst, path, value) {
	  var element = internalInst._currentElement;
	  internalInst._currentElement = _extends({}, element, {
	    props: copyWithSet(element.props, path, value)
	  });
	  internalInst._instance.forceUpdate();
	}
	
	function setInState(inst, path, value) {
	  setIn(inst.state, path, value);
	  inst.forceUpdate();
	}
	
	function setInContext(inst, path, value) {
	  setIn(inst.context, path, value);
	  inst.forceUpdate();
	}
	
	function setIn(obj, path, value) {
	  var last = path.pop();
	  var parent = path.reduce(function (obj_, attr) {
	    return obj_ ? obj_[attr] : null;
	  }, obj);
	  if (parent) {
	    parent[last] = value;
	  }
	}
	
	function childrenList(children) {
	  var res = [];
	  for (var name in children) {
	    res.push(children[name]);
	  }
	  return res;
	}
	
	module.exports = getData;

/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function copyWithSetImpl(obj, path, idx, value) {
	  if (idx >= path.length) {
	    return value;
	  }
	  var key = path[idx];
	  var updated = Array.isArray(obj) ? obj.slice() : _extends({}, obj);
	  // $FlowFixMe number or string is fine here
	  updated[key] = copyWithSetImpl(obj[key], path, idx + 1, value);
	  return updated;
	}
	
	function copyWithSet(obj, path, value) {
	  return copyWithSetImpl(obj, path, 0, value);
	}
	
	module.exports = copyWithSet;

/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var FB_MODULE_RE = /^(.*) \[from (.*)\]$/;
	var cachedDisplayNames = new WeakMap();
	
	function getDisplayName(type) {
	  if (cachedDisplayNames.has(type)) {
	    return cachedDisplayNames.get(type);
	  }
	
	  var displayName = type.displayName || type.name || 'Unknown';
	  // Facebook-specific hack to turn "Image [from Image.react]" into just "Image".
	  // We need displayName with module name for error reports but it clutters the DevTools.
	  var match = displayName.match(FB_MODULE_RE);
	  if (match) {
	    var componentName = match[1];
	    var moduleName = match[2];
	    if (componentName && moduleName) {
	      if (moduleName === componentName || moduleName.startsWith(componentName + '.')) {
	        displayName = componentName;
	      }
	    }
	  }
	
	  cachedDisplayNames.set(type, displayName);
	  return displayName;
	}
	
	module.exports = getDisplayName;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var copyWithSet = __webpack_require__(37);
	
	function getData012(internalInstance) {
	  var children = null;
	  var props = internalInstance.props;
	  var state = internalInstance.state;
	  var context = internalInstance.context;
	  var updater = null;
	  var name = null;
	  var type = null;
	  var key = null;
	  var ref = null;
	  var text = null;
	  var publicInstance = null;
	  var nodeType = 'Native';
	  if (internalInstance._renderedComponent) {
	    nodeType = 'Wrapper';
	    children = [internalInstance._renderedComponent];
	    if (context && Object.keys(context).length === 0) {
	      context = null;
	    }
	  } else if (internalInstance._renderedChildren) {
	    name = internalInstance.constructor.displayName;
	    children = childrenList(internalInstance._renderedChildren);
	  } else if (typeof props.children === 'string') {
	    // string children
	    name = internalInstance.constructor.displayName;
	    children = props.children;
	    nodeType = 'Native';
	  }
	
	  if (!props && internalInstance._currentElement && internalInstance._currentElement.props) {
	    props = internalInstance._currentElement.props;
	  }
	
	  if (internalInstance._currentElement) {
	    type = internalInstance._currentElement.type;
	    if (internalInstance._currentElement.key) {
	      key = String(internalInstance._currentElement.key);
	    }
	    ref = internalInstance._currentElement.ref;
	    if (typeof type === 'string') {
	      name = type;
	    } else {
	      nodeType = 'Composite';
	      name = type.displayName;
	      if (!name) {
	        name = 'No display name';
	      }
	    }
	  }
	
	  if (!name) {
	    name = internalInstance.constructor.displayName || 'No display name';
	    nodeType = 'Composite';
	  }
	
	  if (typeof props === 'string') {
	    nodeType = 'Text';
	    text = props;
	    props = null;
	    name = null;
	  }
	
	  if (internalInstance.forceUpdate) {
	    updater = {
	      setState: internalInstance.setState.bind(internalInstance),
	      forceUpdate: internalInstance.forceUpdate.bind(internalInstance),
	      setInProps: internalInstance.forceUpdate && setInProps.bind(null, internalInstance),
	      setInState: internalInstance.forceUpdate && setInState.bind(null, internalInstance),
	      setInContext: internalInstance.forceUpdate && setInContext.bind(null, internalInstance)
	    };
	    publicInstance = internalInstance;
	  }
	
	  return {
	    nodeType: nodeType,
	    type: type,
	    key: key,
	    ref: ref,
	    source: null,
	    name: name,
	    props: props,
	    state: state,
	    context: context,
	    children: children,
	    text: text,
	    updater: updater,
	    publicInstance: publicInstance
	  };
	}
	
	function setInProps(inst, path, value) {
	  inst.props = copyWithSet(inst.props, path, value);
	  inst.forceUpdate();
	}
	
	function setInState(inst, path, value) {
	  setIn(inst.state, path, value);
	  inst.forceUpdate();
	}
	
	function setInContext(inst, path, value) {
	  setIn(inst.context, path, value);
	  inst.forceUpdate();
	}
	
	function setIn(obj, path, value) {
	  var last = path.pop();
	  var parent = path.reduce(function (obj_, attr) {
	    return obj_ ? obj_[attr] : null;
	  }, obj);
	  if (parent) {
	    parent[last] = value;
	  }
	}
	
	function childrenList(children) {
	  var res = [];
	  for (var name in children) {
	    res.push(children[name]);
	  }
	  return res;
	}
	
	module.exports = getData012;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var getDataFiber = __webpack_require__(41);
	
	var _require = __webpack_require__(42),
	    ClassComponent = _require.ClassComponent,
	    HostRoot = _require.HostRoot;
	
	function attachRendererFiber(hook, rid, renderer) {
	  // This is a slightly annoying indirection.
	  // It is currently necessary because DevTools wants
	  // to use unique objects as keys for instances.
	  // However fibers have two versions.
	  // We use this set to remember first encountered fiber for
	  // each conceptual instance.
	  var opaqueNodes = new Set();
	  function getOpaqueNode(fiber) {
	    if (opaqueNodes.has(fiber)) {
	      return fiber;
	    }
	    var alternate = fiber.alternate;
	
	    if (alternate != null && opaqueNodes.has(alternate)) {
	      return alternate;
	    }
	    opaqueNodes.add(fiber);
	    return fiber;
	  }
	
	  function hasDataChanged(prevFiber, nextFiber) {
	    if (prevFiber.tag === ClassComponent) {
	      // Only classes have context.
	      if (prevFiber.stateNode.context !== nextFiber.stateNode.context) {
	        return true;
	      }
	      // Force updating won't update state or props.
	      if (nextFiber.updateQueue != null && nextFiber.updateQueue.hasForceUpdate) {
	        return true;
	      }
	    }
	    // Compare the fields that would result in observable changes in DevTools.
	    // We don't compare type, tag, index, and key, because these are known to match.
	    return prevFiber.memoizedProps !== nextFiber.memoizedProps || prevFiber.memoizedState !== nextFiber.memoizedState || prevFiber.ref !== nextFiber.ref || prevFiber._debugSource !== nextFiber._debugSource;
	  }
	
	  var pendingEvents = [];
	
	  function flushPendingEvents() {
	    var events = pendingEvents;
	    pendingEvents = [];
	    for (var i = 0; i < events.length; i++) {
	      var event = events[i];
	      hook.emit(event.type, event);
	    }
	  }
	
	  function enqueueMount(fiber) {
	    pendingEvents.push({
	      internalInstance: getOpaqueNode(fiber),
	      data: getDataFiber(fiber, getOpaqueNode),
	      renderer: rid,
	      type: 'mount'
	    });
	
	    var isRoot = fiber.tag === HostRoot;
	    if (isRoot) {
	      pendingEvents.push({
	        internalInstance: getOpaqueNode(fiber),
	        renderer: rid,
	        type: 'root'
	      });
	    }
	  }
	
	  function enqueueUpdateIfNecessary(fiber, hasChildOrderChanged) {
	    if (!hasChildOrderChanged && !hasDataChanged(fiber.alternate, fiber)) {
	      return;
	    }
	    pendingEvents.push({
	      internalInstance: getOpaqueNode(fiber),
	      data: getDataFiber(fiber, getOpaqueNode),
	      renderer: rid,
	      type: 'update'
	    });
	  }
	
	  function enqueueUnmount(fiber) {
	    var isRoot = fiber.tag === HostRoot;
	    var opaqueNode = getOpaqueNode(fiber);
	    var event = {
	      internalInstance: opaqueNode,
	      renderer: rid,
	      type: 'unmount'
	    };
	    if (isRoot) {
	      pendingEvents.push(event);
	    } else {
	      // Non-root fibers are deleted during the commit phase.
	      // They are deleted in the child-first order. However
	      // DevTools currently expects deletions to be parent-first.
	      // This is why we unshift deletions rather than push them.
	      pendingEvents.unshift(event);
	    }
	    opaqueNodes.delete(opaqueNode);
	  }
	
	  function mountFiber(fiber) {
	    // Depth-first.
	    // Logs mounting of children first, parents later.
	    var node = fiber;
	    outer: while (true) {
	      if (node.child) {
	        node.child.return = node;
	        node = node.child;
	        continue;
	      }
	      enqueueMount(node);
	      if (node == fiber) {
	        return;
	      }
	      if (node.sibling) {
	        node.sibling.return = node.return;
	        node = node.sibling;
	        continue;
	      }
	      while (node.return) {
	        node = node.return;
	        enqueueMount(node);
	        if (node == fiber) {
	          return;
	        }
	        if (node.sibling) {
	          node.sibling.return = node.return;
	          node = node.sibling;
	          continue outer;
	        }
	      }
	      return;
	    }
	  }
	
	  function updateFiber(nextFiber, prevFiber) {
	    var hasChildOrderChanged = false;
	    if (nextFiber.child !== prevFiber.child) {
	      // If the first child is different, we need to traverse them.
	      // Each next child will be either a new child (mount) or an alternate (update).
	      var nextChild = nextFiber.child;
	      var prevChildAtSameIndex = prevFiber.child;
	      while (nextChild) {
	        // We already know children will be referentially different because
	        // they are either new mounts or alternates of previous children.
	        // Schedule updates and mounts depending on whether alternates exist.
	        // We don't track deletions here because they are reported separately.
	        if (nextChild.alternate) {
	          var prevChild = nextChild.alternate;
	          updateFiber(nextChild, prevChild);
	          // However we also keep track if the order of the children matches
	          // the previous order. They are always different referentially, but
	          // if the instances line up conceptually we'll want to know that.
	          if (!hasChildOrderChanged && prevChild !== prevChildAtSameIndex) {
	            hasChildOrderChanged = true;
	          }
	        } else {
	          mountFiber(nextChild);
	          if (!hasChildOrderChanged) {
	            hasChildOrderChanged = true;
	          }
	        }
	        // Try the next child.
	        nextChild = nextChild.sibling;
	        // Advance the pointer in the previous list so that we can
	        // keep comparing if they line up.
	        if (!hasChildOrderChanged && prevChildAtSameIndex != null) {
	          prevChildAtSameIndex = prevChildAtSameIndex.sibling;
	        }
	      }
	      // If we have no more children, but used to, they don't line up.
	      if (!hasChildOrderChanged && prevChildAtSameIndex != null) {
	        hasChildOrderChanged = true;
	      }
	    }
	    enqueueUpdateIfNecessary(nextFiber, hasChildOrderChanged);
	  }
	
	  function walkTree() {
	    hook.getFiberRoots(rid).forEach(function (root) {
	      // Hydrate all the roots for the first time.
	      mountFiber(root.current);
	    });
	    flushPendingEvents();
	  }
	
	  function cleanup() {
	    // We don't patch any methods so there is no cleanup.
	  }
	
	  function handleCommitFiberUnmount(fiber) {
	    // This is not recursive.
	    // We can't traverse fibers after unmounting so instead
	    // we rely on React telling us about each unmount.
	    // It will be flushed after the root is committed.
	    enqueueUnmount(fiber);
	  }
	
	  function handleCommitFiberRoot(root) {
	    var current = root.current;
	    var alternate = current.alternate;
	    if (alternate) {
	      // TODO: relying on this seems a bit fishy.
	      var wasMounted = alternate.memoizedState != null && alternate.memoizedState.element != null;
	      var isMounted = current.memoizedState != null && current.memoizedState.element != null;
	      if (!wasMounted && isMounted) {
	        // Mount a new root.
	        mountFiber(current);
	      } else if (wasMounted && isMounted) {
	        // Update an existing root.
	        updateFiber(current, alternate);
	      } else if (wasMounted && !isMounted) {
	        // Unmount an existing root.
	        enqueueUnmount(current);
	      }
	    } else {
	      // Mount a new root.
	      mountFiber(current);
	    }
	    // We're done here.
	    flushPendingEvents();
	  }
	
	  // The naming is confusing.
	  // They deal with opaque nodes (fibers), not elements.
	  function getNativeFromReactElement(fiber) {
	    try {
	      var opaqueNode = fiber;
	      var hostInstance = renderer.findHostInstanceByFiber(opaqueNode);
	      return hostInstance;
	    } catch (err) {
	      // The fiber might have unmounted by now.
	      return null;
	    }
	  }
	  function getReactElementFromNative(hostInstance) {
	    var fiber = renderer.findFiberByHostInstance(hostInstance);
	    if (fiber != null) {
	      // TODO: type fibers.
	      var opaqueNode = getOpaqueNode(fiber);
	      return opaqueNode;
	    }
	    return null;
	  }
	  return {
	    getNativeFromReactElement: getNativeFromReactElement,
	    getReactElementFromNative: getReactElementFromNative,
	    handleCommitFiberRoot: handleCommitFiberRoot,
	    handleCommitFiberUnmount: handleCommitFiberUnmount,
	    cleanup: cleanup,
	    walkTree: walkTree
	  };
	}
	
	module.exports = attachRendererFiber;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var copyWithSet = __webpack_require__(37);
	var getDisplayName = __webpack_require__(38);
	
	var _require = __webpack_require__(42),
	    FunctionalComponent = _require.FunctionalComponent,
	    ClassComponent = _require.ClassComponent,
	    HostRoot = _require.HostRoot,
	    HostPortal = _require.HostPortal,
	    HostComponent = _require.HostComponent,
	    HostText = _require.HostText,
	    Fragment = _require.Fragment;
	
	// TODO: we might want to change the data structure
	// once we no longer suppport Stack versions of `getData`.
	
	
	function getDataFiber(fiber, getOpaqueNode) {
	  var type = fiber.type;
	  var key = fiber.key;
	  var ref = fiber.ref;
	  var source = fiber._debugSource;
	  var publicInstance = null;
	  var props = null;
	  var state = null;
	  var children = null;
	  var context = null;
	  var updater = null;
	  var nodeType = null;
	  var name = null;
	  var text = null;
	
	  switch (fiber.tag) {
	    case FunctionalComponent:
	    case ClassComponent:
	      nodeType = 'Composite';
	      name = getDisplayName(fiber.type);
	      publicInstance = fiber.stateNode;
	      props = fiber.memoizedProps;
	      state = fiber.memoizedState;
	      if (publicInstance != null) {
	        context = publicInstance.context;
	        if (context && Object.keys(context).length === 0) {
	          context = null;
	        }
	      }
	      var inst = publicInstance;
	      if (inst) {
	        updater = {
	          setState: inst.setState && inst.setState.bind(inst),
	          forceUpdate: inst.forceUpdate && inst.forceUpdate.bind(inst),
	          setInProps: inst.forceUpdate && setInProps.bind(null, fiber),
	          setInState: inst.forceUpdate && setInState.bind(null, inst),
	          setInContext: inst.forceUpdate && setInContext.bind(null, inst)
	        };
	      }
	      children = [];
	      break;
	    case HostRoot:
	      nodeType = 'Wrapper';
	      children = [];
	      break;
	    case HostPortal:
	      nodeType = 'Portal';
	      name = 'ReactPortal';
	      props = {
	        target: fiber.stateNode.containerInfo
	      };
	      children = [];
	      break;
	    case HostComponent:
	      nodeType = 'Native';
	      name = fiber.type;
	      publicInstance = fiber.stateNode;
	      props = fiber.memoizedProps;
	      if (typeof props.children === 'string' || typeof props.children === 'number') {
	        children = props.children.toString();
	      } else {
	        children = [];
	      }
	      break;
	    case HostText:
	      nodeType = 'Text';
	      text = fiber.memoizedProps;
	      break;
	    case Fragment:
	      nodeType = 'Wrapper';
	      children = [];
	      break;
	    default:
	      // Coroutines and yields
	      nodeType = 'Native';
	      props = fiber.memoizedProps;
	      name = 'TODO_NOT_IMPLEMENTED_YET';
	      children = [];
	      break;
	  }
	
	  if (Array.isArray(children)) {
	    var child = fiber.child;
	    while (child) {
	      children.push(getOpaqueNode(child));
	      child = child.sibling;
	    }
	  }
	
	  return {
	    nodeType: nodeType,
	    type: type,
	    key: key,
	    ref: ref,
	    source: source,
	    name: name,
	    props: props,
	    state: state,
	    context: context,
	    children: children,
	    text: text,
	    updater: updater,
	    publicInstance: publicInstance
	  };
	}
	
	function setInProps(fiber, path, value) {
	  fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
	  fiber.stateNode.forceUpdate();
	}
	
	function setInState(inst, path, value) {
	  setIn(inst.state, path, value);
	  inst.forceUpdate();
	}
	
	function setInContext(inst, path, value) {
	  setIn(inst.context, path, value);
	  inst.forceUpdate();
	}
	
	function setIn(obj, path, value) {
	  var last = path.pop();
	  var parent = path.reduce(function (obj_, attr) {
	    return obj_ ? obj_[attr] : null;
	  }, obj);
	  if (parent) {
	    parent[last] = value;
	  }
	}
	
	module.exports = getDataFiber;

/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	// Copied from React repo.
	
	module.exports = {
	  IndeterminateComponent: 0, // Before we know whether it is functional or class
	  FunctionalComponent: 1,
	  ClassComponent: 2,
	  HostRoot: 3, // Root of a host tree. Could be nested inside another node.
	  HostPortal: 4, // A subtree. Could be an entry point to a different renderer.
	  HostComponent: 5,
	  HostText: 6,
	  CoroutineComponent: 7,
	  CoroutineHandlerPhase: 8,
	  YieldComponent: 9,
	  Fragment: 10
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var resolveBoxStyle = __webpack_require__(44);
	
	module.exports = function setupRNStyle(bridge, agent, resolveRNStyle) {
	  bridge.onCall('rn-style:get', function (id) {
	    var node = agent.elementData.get(id);
	    if (!node || !node.props) {
	      return null;
	    }
	    return resolveRNStyle(node.props.style);
	  });
	
	  bridge.on('rn-style:measure', function (id) {
	    measureStyle(agent, bridge, resolveRNStyle, id);
	  });
	
	  bridge.on('rn-style:rename', function (_ref) {
	    var id = _ref.id,
	        oldName = _ref.oldName,
	        newName = _ref.newName,
	        val = _ref.val;
	
	    renameStyle(agent, id, oldName, newName, val);
	    setTimeout(function () {
	      return measureStyle(agent, bridge, resolveRNStyle, id);
	    });
	  });
	
	  bridge.on('rn-style:set', function (_ref2) {
	    var id = _ref2.id,
	        attr = _ref2.attr,
	        val = _ref2.val;
	
	    setStyle(agent, id, attr, val);
	    setTimeout(function () {
	      return measureStyle(agent, bridge, resolveRNStyle, id);
	    });
	  });
	};
	
	var blank = {
	  top: 0,
	  left: 0,
	  right: 0,
	  bottom: 0
	};
	
	function measureStyle(agent, bridge, resolveRNStyle, id) {
	  var node = agent.elementData.get(id);
	  if (!node || !node.props) {
	    bridge.send('rn-style:measure', {});
	    return;
	  }
	  var style = resolveRNStyle(node.props.style);
	
	  var instance = node.publicInstance;
	  if (!instance || !instance.measure) {
	    bridge.send('rn-style:measure', { style: style });
	    return;
	  }
	
	  instance.measure(function (x, y, width, height, left, top) {
	    var margin = style && resolveBoxStyle('margin', style) || blank;
	    var padding = style && resolveBoxStyle('padding', style) || blank;
	    bridge.send('rn-style:measure', {
	      style: style,
	      measuredLayout: {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        left: left,
	        top: top,
	        margin: margin,
	        padding: padding
	      }
	    });
	  });
	}
	
	function shallowClone(obj) {
	  var nobj = {};
	  for (var n in obj) {
	    nobj[n] = obj[n];
	  }
	  return nobj;
	}
	
	function renameStyle(agent, id, oldName, newName, val) {
	  var data = agent.elementData.get(id);
	  var newStyle = _defineProperty({}, newName, val);
	  if (!data || !data.updater || !data.updater.setInProps) {
	    var el = agent.internalInstancesById.get(id);
	    if (el && el.setNativeProps) {
	      el.setNativeProps({ style: newStyle });
	    } else {
	      console.error('Unable to set style for this element... (no forceUpdate or setNativeProps)');
	    }
	    return;
	  }
	  var style = data && data.props && data.props.style;
	  var customStyle;
	  if (Array.isArray(style)) {
	    if (_typeof(style[style.length - 1]) === 'object' && !Array.isArray(style[style.length - 1])) {
	      customStyle = shallowClone(style[style.length - 1]);
	      delete customStyle[oldName];
	      customStyle[newName] = val;
	      // $FlowFixMe we know that updater is not null here
	      data.updater.setInProps(['style', style.length - 1], customStyle);
	    } else {
	      style = style.concat([newStyle]);
	      // $FlowFixMe we know that updater is not null here
	      data.updater.setInProps(['style'], style);
	    }
	  } else {
	    if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) === 'object') {
	      customStyle = shallowClone(style);
	      delete customStyle[oldName];
	      customStyle[newName] = val;
	      // $FlowFixMe we know that updater is not null here
	      data.updater.setInProps(['style'], customStyle);
	    } else {
	      style = [style, newStyle];
	      data.updater.setInProps(['style'], style);
	    }
	  }
	  agent.emit('hideHighlight');
	}
	
	function setStyle(agent, id, attr, val) {
	  var data = agent.elementData.get(id);
	  var newStyle = _defineProperty({}, attr, val);
	  if (!data || !data.updater || !data.updater.setInProps) {
	    var el = agent.internalInstancesById.get(id);
	    if (el && el.setNativeProps) {
	      el.setNativeProps({ style: newStyle });
	    } else {
	      console.error('Unable to set style for this element... (no forceUpdate or setNativeProps)');
	    }
	    return;
	  }
	  var style = data.props && data.props.style;
	  if (Array.isArray(style)) {
	    if (_typeof(style[style.length - 1]) === 'object' && !Array.isArray(style[style.length - 1])) {
	      // $FlowFixMe we know that updater is not null here
	      data.updater.setInProps(['style', style.length - 1, attr], val);
	    } else {
	      style = style.concat([newStyle]);
	      // $FlowFixMe we know that updater is not null here
	      data.updater.setInProps(['style'], style);
	    }
	  } else {
	    style = [style, newStyle];
	    data.updater.setInProps(['style'], style);
	  }
	  agent.emit('hideHighlight');
	}

/***/ },
/* 44 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	/**
	 * This is mirror from
	 * https://github.com/facebook/react-native/blob/master/Libraries/Inspector/resolveBoxStyle.js
	 *
	 * Resolve a style property into it's component parts, e.g.
	 *
	 * resolveBoxStyle('margin', {margin: 5, marginBottom: 10})
	 * ->
	 * {top: 5, left: 5, right: 5, bottom: 10}
	 *
	 * If none are set, returns false.
	 */
	function resolveBoxStyle(prefix, style) {
	  var res = {};
	  var subs = ['top', 'left', 'bottom', 'right'];
	  var set = false;
	  subs.forEach(function (sub) {
	    res[sub] = style[prefix] || 0;
	  });
	  if (style[prefix]) {
	    set = true;
	  }
	  if (style[prefix + 'Vertical']) {
	    res.top = res.bottom = style[prefix + 'Vertical'];
	    set = true;
	  }
	  if (style[prefix + 'Horizontal']) {
	    res.left = res.right = style[prefix + 'Horizontal'];
	    set = true;
	  }
	  subs.forEach(function (sub) {
	    var val = style[prefix + capFirst(sub)];
	    if (val) {
	      res[sub] = val;
	      set = true;
	    }
	  });
	  if (!set) {
	    return null;
	  }
	  return res;
	}
	
	function capFirst(text) {
	  return text[0].toUpperCase() + text.slice(1);
	}
	
	module.exports = resolveBoxStyle;

/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	function decorate(obj, attr, fn) {
	  var old = obj[attr];
	  obj[attr] = function () {
	    var res = old.apply(this, arguments);
	    fn.apply(this, arguments);
	    return res;
	  };
	  return function () {
	    obj[attr] = old;
	  };
	}
	
	var subscriptionEnabled = false;
	
	module.exports = function (bridge, agent, hook) {
	  var shouldEnable = !!hook._relayInternals;
	
	  bridge.onCall('relay:check', function () {
	    return shouldEnable;
	  });
	  if (!shouldEnable) {
	    return;
	  }
	  var _hook$_relayInternals = hook._relayInternals,
	      DefaultStoreData = _hook$_relayInternals.DefaultStoreData,
	      setRequestListener = _hook$_relayInternals.setRequestListener;
	
	
	  function sendStoreData() {
	    if (subscriptionEnabled) {
	      bridge.send('relay:store', {
	        id: 'relay:store',
	        nodes: DefaultStoreData.getNodeData()
	      });
	    }
	  }
	
	  bridge.onCall('relay:store:enable', function () {
	    subscriptionEnabled = true;
	    sendStoreData();
	  });
	
	  bridge.onCall('relay:store:disable', function () {
	    subscriptionEnabled = false;
	  });
	
	  sendStoreData();
	  decorate(DefaultStoreData, 'handleUpdatePayload', sendStoreData);
	  decorate(DefaultStoreData, 'handleQueryPayload', sendStoreData);
	
	  var removeListener = setRequestListener(function (event, data) {
	    bridge.send(event, data);
	  });
	  hook.on('shutdown', removeListener);
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var Highlighter = __webpack_require__(47);
	
	module.exports = function setup(agent) {
	  var hl = new Highlighter(window, function (node) {
	    agent.selectFromDOMNode(node);
	  });
	  agent.on('highlight', function (data) {
	    return hl.highlight(data.node, data.name);
	  });
	  agent.on('highlightMany', function (nodes) {
	    return hl.highlightMany(nodes);
	  });
	  agent.on('hideHighlight', function () {
	    return hl.hideHighlight();
	  });
	  agent.on('refreshMultiOverlay', function () {
	    return hl.refreshMultiOverlay();
	  });
	  agent.on('startInspecting', function () {
	    return hl.startInspecting();
	  });
	  agent.on('stopInspecting', function () {
	    return hl.stopInspecting();
	  });
	  agent.on('shutdown', function () {
	    hl.remove();
	  });
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Overlay = __webpack_require__(48);
	var MultiOverlay = __webpack_require__(49);
	
	/**
	 * Manages the highlighting of items on an html page, as well as
	 * hover-to-inspect.
	 */
	
	var Highlighter = function () {
	  function Highlighter(win, onSelect) {
	    _classCallCheck(this, Highlighter);
	
	    this._win = win;
	    this._onSelect = onSelect;
	    this._overlay = null;
	    this._multiOverlay = null;
	    this._subs = [];
	  }
	
	  _createClass(Highlighter, [{
	    key: 'startInspecting',
	    value: function startInspecting() {
	      this._inspecting = true;
	      this._subs = [captureSubscription(this._win, 'mouseover', this.onHover.bind(this)), captureSubscription(this._win, 'mousedown', this.onMouseDown.bind(this)), captureSubscription(this._win, 'click', this.onClick.bind(this))];
	    }
	  }, {
	    key: 'stopInspecting',
	    value: function stopInspecting() {
	      this._subs.forEach(function (unsub) {
	        return unsub();
	      });
	      this.hideHighlight();
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      this.stopInspecting();
	      if (this._button && this._button.parentNode) {
	        this._button.parentNode.removeChild(this._button);
	      }
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(node, name) {
	      this.removeMultiOverlay();
	      if (node.nodeType !== Node.COMMENT_NODE) {
	        if (!this._overlay) {
	          this._overlay = new Overlay(this._win);
	        }
	        this._overlay.inspect(node, name);
	      }
	    }
	  }, {
	    key: 'highlightMany',
	    value: function highlightMany(nodes) {
	      this.removeOverlay();
	      if (!this._multiOverlay) {
	        this._multiOverlay = new MultiOverlay(this._win);
	      }
	      this._multiOverlay.highlightMany(nodes);
	    }
	  }, {
	    key: 'hideHighlight',
	    value: function hideHighlight() {
	      this._inspecting = false;
	      this.removeOverlay();
	      this.removeMultiOverlay();
	    }
	  }, {
	    key: 'refreshMultiOverlay',
	    value: function refreshMultiOverlay() {
	      if (!this._multiOverlay) {
	        return;
	      }
	      this._multiOverlay.refresh();
	    }
	  }, {
	    key: 'removeOverlay',
	    value: function removeOverlay() {
	      if (!this._overlay) {
	        return;
	      }
	      this._overlay.remove();
	      this._overlay = null;
	    }
	  }, {
	    key: 'removeMultiOverlay',
	    value: function removeMultiOverlay() {
	      if (!this._multiOverlay) {
	        return;
	      }
	      this._multiOverlay.remove();
	      this._multiOverlay = null;
	    }
	  }, {
	    key: 'onMouseDown',
	    value: function onMouseDown(evt) {
	      if (!this._inspecting) {
	        return;
	      }
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.cancelBubble = true;
	      this._onSelect(evt.target);
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(evt) {
	      if (!this._inspecting) {
	        return;
	      }
	      this._subs.forEach(function (unsub) {
	        return unsub();
	      });
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.cancelBubble = true;
	      this.hideHighlight();
	    }
	  }, {
	    key: 'onHover',
	    value: function onHover(evt) {
	      if (!this._inspecting) {
	        return;
	      }
	      evt.preventDefault();
	      evt.stopPropagation();
	      evt.cancelBubble = true;
	      this.highlight(evt.target);
	    }
	  }, {
	    key: 'injectButton',
	    value: function injectButton() {
	      this._button = makeMagnifier();
	      this._button.onclick = this.startInspecting.bind(this);
	      this._win.document.body.appendChild(this._button);
	    }
	  }]);
	
	  return Highlighter;
	}();
	
	function captureSubscription(obj, evt, cb) {
	  obj.addEventListener(evt, cb, true);
	  return function () {
	    return obj.removeEventListener(evt, cb, true);
	  };
	}
	
	function makeMagnifier() {
	  var button = window.document.createElement('button');
	  button.innerHTML = '&#128269;';
	  button.style.backgroundColor = 'transparent';
	  button.style.border = 'none';
	  button.style.outline = 'none';
	  button.style.cursor = 'pointer';
	  button.style.position = 'fixed';
	  button.style.bottom = '10px';
	  button.style.right = '10px';
	  button.style.fontSize = '30px';
	  button.style.zIndex = 10000000;
	  return button;
	}
	
	module.exports = Highlighter;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var assign = __webpack_require__(3);
	
	var Overlay = function () {
	  function Overlay(window) {
	    _classCallCheck(this, Overlay);
	
	    var doc = window.document;
	    this.win = window;
	    this.container = doc.createElement('div');
	    this.node = doc.createElement('div');
	    this.border = doc.createElement('div');
	    this.padding = doc.createElement('div');
	    this.content = doc.createElement('div');
	
	    this.border.style.borderColor = overlayStyles.border;
	    this.padding.style.borderColor = overlayStyles.padding;
	    this.content.style.backgroundColor = overlayStyles.background;
	
	    assign(this.node.style, {
	      borderColor: overlayStyles.margin,
	      pointerEvents: 'none',
	      position: 'fixed'
	    });
	
	    this.tip = doc.createElement('div');
	    assign(this.tip.style, {
	      border: '1px solid #aaa',
	      backgroundColor: 'rgb(255, 255, 178)',
	      fontFamily: 'sans-serif',
	      color: 'orange',
	      padding: '3px 5px',
	      position: 'fixed',
	      fontSize: '10px'
	    });
	
	    this.nameSpan = doc.createElement('span');
	    this.tip.appendChild(this.nameSpan);
	    assign(this.nameSpan.style, {
	      color: 'rgb(136, 18, 128)',
	      marginRight: '5px'
	    });
	    this.dimSpan = doc.createElement('span');
	    this.tip.appendChild(this.dimSpan);
	    assign(this.dimSpan.style, {
	      color: '#888'
	    });
	
	    this.container.style.zIndex = 10000000;
	    this.node.style.zIndex = 10000000;
	    this.tip.style.zIndex = 10000000;
	    this.container.appendChild(this.node);
	    this.container.appendChild(this.tip);
	    this.node.appendChild(this.border);
	    this.border.appendChild(this.padding);
	    this.padding.appendChild(this.content);
	    doc.body.appendChild(this.container);
	  }
	
	  _createClass(Overlay, [{
	    key: 'remove',
	    value: function remove() {
	      if (this.container.parentNode) {
	        this.container.parentNode.removeChild(this.container);
	      }
	    }
	  }, {
	    key: 'inspect',
	    value: function inspect(node, name) {
	      // We can't get the size of text nodes or comment nodes. React as of v15
	      // heavily uses comment nodes to delimit text.
	      if (node.nodeType !== Node.ELEMENT_NODE) {
	        return;
	      }
	      var box = getNestedBoundingClientRect(node, this.win);
	      var dims = getElementDimensions(node);
	
	      boxWrap(dims, 'margin', this.node);
	      boxWrap(dims, 'border', this.border);
	      boxWrap(dims, 'padding', this.padding);
	
	      assign(this.content.style, {
	        height: box.height - dims.borderTop - dims.borderBottom - dims.paddingTop - dims.paddingBottom + 'px',
	        width: box.width - dims.borderLeft - dims.borderRight - dims.paddingLeft - dims.paddingRight + 'px'
	      });
	
	      assign(this.node.style, {
	        top: box.top - dims.marginTop + 'px',
	        left: box.left - dims.marginLeft + 'px'
	      });
	
	      this.nameSpan.textContent = name || node.nodeName.toLowerCase();
	      this.dimSpan.textContent = box.width + 'px × ' + box.height + 'px';
	
	      var tipPos = findTipPos({
	        top: box.top - dims.marginTop,
	        left: box.left - dims.marginLeft,
	        height: box.height + dims.marginTop + dims.marginBottom,
	        width: box.width + dims.marginLeft + dims.marginRight
	      }, this.win);
	      assign(this.tip.style, tipPos);
	    }
	  }]);
	
	  return Overlay;
	}();
	
	function findTipPos(dims, win) {
	  var tipHeight = 20;
	  var margin = 5;
	  var top;
	  if (dims.top + dims.height + tipHeight <= win.innerHeight) {
	    if (dims.top + dims.height < 0) {
	      top = margin;
	    } else {
	      top = dims.top + dims.height + margin;
	    }
	  } else if (dims.top - tipHeight <= win.innerHeight) {
	    if (dims.top - tipHeight - margin < margin) {
	      top = margin;
	    } else {
	      top = dims.top - tipHeight - margin;
	    }
	  } else {
	    top = win.innerHeight - tipHeight - margin;
	  }
	
	  top += 'px';
	
	  if (dims.left < 0) {
	    return { top: top, left: margin };
	  }
	  if (dims.left + 200 > win.innerWidth) {
	    return { top: top, right: margin };
	  }
	  return { top: top, left: dims.left + margin + 'px' };
	}
	
	function getElementDimensions(domElement) {
	  var calculatedStyle = window.getComputedStyle(domElement);
	
	  return {
	    borderLeft: +calculatedStyle.borderLeftWidth.match(/[0-9]*/)[0],
	    borderRight: +calculatedStyle.borderRightWidth.match(/[0-9]*/)[0],
	    borderTop: +calculatedStyle.borderTopWidth.match(/[0-9]*/)[0],
	    borderBottom: +calculatedStyle.borderBottomWidth.match(/[0-9]*/)[0],
	    marginLeft: +calculatedStyle.marginLeft.match(/[0-9]*/)[0],
	    marginRight: +calculatedStyle.marginRight.match(/[0-9]*/)[0],
	    marginTop: +calculatedStyle.marginTop.match(/[0-9]*/)[0],
	    marginBottom: +calculatedStyle.marginBottom.match(/[0-9]*/)[0],
	    paddingLeft: +calculatedStyle.paddingLeft.match(/[0-9]*/)[0],
	    paddingRight: +calculatedStyle.paddingRight.match(/[0-9]*/)[0],
	    paddingTop: +calculatedStyle.paddingTop.match(/[0-9]*/)[0],
	    paddingBottom: +calculatedStyle.paddingBottom.match(/[0-9]*/)[0]
	  };
	}
	
	// Get the window object for the document that a node belongs to,
	// or return null if it cannot be found (node not attached to DOM,
	// etc).
	function getOwnerWindow(node) {
	  if (!node.ownerDocument) {
	    return null;
	  }
	  return node.ownerDocument.defaultView;
	}
	
	// Get the iframe containing a node, or return null if it cannot
	// be found (node not within iframe, etc).
	function getOwnerIframe(node) {
	  var nodeWindow = getOwnerWindow(node);
	  if (nodeWindow) {
	    return nodeWindow.frameElement;
	  }
	  return null;
	}
	
	// Get a bounding client rect for a node, with an
	// offset added to compensate for its border.
	function getBoundingClientRectWithBorderOffset(node) {
	  var dimensions = getElementDimensions(node);
	
	  return mergeRectOffsets([node.getBoundingClientRect(), {
	    top: dimensions.borderTop,
	    left: dimensions.borderLeft,
	    bottom: dimensions.borderBottom,
	    right: dimensions.borderRight,
	    // This width and height won't get used by mergeRectOffsets (since this
	    // is not the first rect in the array), but we set them so that this
	    // object typechecks as a DOMRect.
	    width: 0,
	    height: 0
	  }]);
	}
	
	// Add together the top, left, bottom, and right properties of
	// each DOMRect, but keep the width and height of the first one.
	function mergeRectOffsets(rects) {
	  return rects.reduce(function (previousRect, rect) {
	    if (previousRect == null) {
	      return rect;
	    }
	
	    return {
	      top: previousRect.top + rect.top,
	      left: previousRect.left + rect.left,
	      width: previousRect.width,
	      height: previousRect.height,
	      bottom: previousRect.bottom + rect.bottom,
	      right: previousRect.right + rect.right
	    };
	  });
	}
	
	// Calculate a boundingClientRect for a node relative to boundaryWindow,
	// taking into account any offsets caused by intermediate iframes.
	function getNestedBoundingClientRect(node, boundaryWindow) {
	  var ownerIframe = getOwnerIframe(node);
	  if (ownerIframe && ownerIframe !== boundaryWindow) {
	    var rects = [node.getBoundingClientRect()];
	    var currentIframe = ownerIframe;
	    var onlyOneMore = false;
	    while (currentIframe) {
	      var rect = getBoundingClientRectWithBorderOffset(currentIframe);
	      rects.push(rect);
	      currentIframe = getOwnerIframe(currentIframe);
	
	      if (onlyOneMore) {
	        break;
	      }
	      // We don't want to calculate iframe offsets upwards beyond
	      // the iframe containing the boundaryWindow, but we
	      // need to calculate the offset relative to the boundaryWindow.
	      if (currentIframe && getOwnerWindow(currentIframe) === boundaryWindow) {
	        onlyOneMore = true;
	      }
	    }
	
	    return mergeRectOffsets(rects);
	  } else {
	    return node.getBoundingClientRect();
	  }
	}
	
	function boxWrap(dims, what, node) {
	  assign(node.style, {
	    borderTopWidth: dims[what + 'Top'] + 'px',
	    borderLeftWidth: dims[what + 'Left'] + 'px',
	    borderRightWidth: dims[what + 'Right'] + 'px',
	    borderBottomWidth: dims[what + 'Bottom'] + 'px',
	    borderStyle: 'solid'
	  });
	}
	
	var overlayStyles = {
	  background: 'rgba(120, 170, 210, 0.7)',
	  padding: 'rgba(77, 200, 0, 0.3)',
	  margin: 'rgba(255, 155, 0, 0.3)',
	  border: 'rgba(255, 200, 50, 0.3)'
	};
	
	module.exports = Overlay;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var assign = __webpack_require__(3);
	
	var MultiOverlay = function () {
	  function MultiOverlay(window) {
	    _classCallCheck(this, MultiOverlay);
	
	    this.win = window;
	    var doc = window.document;
	    this.container = doc.createElement('div');
	    doc.body.appendChild(this.container);
	    this._currentNodes = null;
	  }
	
	  _createClass(MultiOverlay, [{
	    key: 'highlightMany',
	    value: function highlightMany(nodes) {
	      var _this = this;
	
	      this._currentNodes = nodes;
	      this.container.innerHTML = '';
	
	      nodes.forEach(function (node) {
	        var div = _this.win.document.createElement('div');
	        if (typeof node.getBoundingClientRect !== 'function') {
	          return;
	        }
	        var box = node.getBoundingClientRect();
	        if (box.bottom < 0 || box.top > window.innerHeight) {
	          return;
	        }
	        assign(div.style, {
	          top: box.top + 'px',
	          left: box.left + 'px',
	          width: box.width + 'px',
	          height: box.height + 'px',
	          border: '2px dotted rgba(200, 100, 100, .8)',
	          boxSizing: 'border-box',
	          backgroundColor: 'rgba(200, 100, 100, .2)',
	          position: 'fixed',
	          zIndex: 10000000,
	          pointerEvents: 'none'
	        });
	        _this.container.appendChild(div);
	      });
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      if (this._currentNodes) {
	        this.highlightMany(this._currentNodes);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this.container.parentNode) {
	        this.container.parentNode.removeChild(this.container);
	        this._currentNodes = null;
	      }
	    }
	  }]);
	
	  return MultiOverlay;
	}();
	
	module.exports = MultiOverlay;

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** backend.js
 **/